<template>
  <div class="mb-4">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <b-tabs pills card v-model="activeTab" @input="onTabChange">
        <b-tab title="FTIE Ticket Basic Info" active>
          <div class="caption-label">FTIE Ticket Basic Information</div>
          <div class="row mb-4">
            <div class="col-4">
              <div class="header-col">
                <div>FTIE ID</div>
                <div>
                  {{ _.get(ftie_page_obj, 'ftie_id', '') }}
                  <a v-if="ftie_page_obj !== null
                     && (approveProposalPermission() || editSubjectPermisson() || checkTransferL1Permission())
                     && _.get(ftie_page_obj, 'salesforce_es_id', null) != null"
                     class="link"
                     target="_blank"
                     :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ _.get(ftie_page_obj, 'salesforce_es_id', null) }`)">
                    (view ES details)
                  </a>
                </div>
              </div>


              <div class="header-col">
                <div>Device</div>
                <div>{{ _.get(ftie_page_obj, 'device', '') }}</div>
              </div>
              <!-- new region for ETO PreCheck Flag -->
              <div v-if="etoPrecheckEnable" class="header-col">
                <div>
                  <span style="
                    display: inline-flex;
                    align-items: center;
                    font-family: 'Arial Black', 'Helvetica Neue', sans-serif;
                    color: #005288;
                    text-transform: uppercase;
                    font-size: 11px;
                    font-weight: 900;
                    letter-spacing: -0.5px;
                    line-height: 1;
                    gap: 1px;
                  ">
                    <span>ETO</span>
                    <span style="font-size: 9px; font-weight: 700; align-self: flex-end; padding-bottom: 6px;">Pre</span>
                    <span style="
                      width: 11px;
                      height: 11px;
                      background-color: #89d94c;
                      border-radius: 2px;
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      position: relative;
                      transform: translateY(1px);
                      flex-shrink: 0;
                    ">
                   <span style="
                    display: block;
                    width: 3px;
                    height: 5px;
                    border: solid white;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                    margin-top: -2px;
                  "></span>
                    </span>
                    <sup style="font-size: 7px; font-weight: 700; margin-left: 1px;">®</sup>
                  </span>

                </div>
                <div>GCS Design 1</div>
              </div>
              <!-- end region-->
              <div class="header-col">
                <div>Category</div>
                <div>{{ _.get(ftie_page_obj, 'category', '') }}</div>
              </div>
              <div class="header-col">
                <div>Priority</div>
                <div>{{ _.get(ftie_page_obj, 'priority', '') }}</div>
              </div>
              <div class="header-col">
                <div>Status</div>
                <div>{{ _.get(ftie_page_obj, 'status', '') }}</div>
                <!-- Region ---- TODO: CLOSE TICKET  @click="showChangeOwnerModal"-->
                <div v-if="ftie_page_obj !== null
                     && _.get(ftie_page_obj, 'status', '') !== 'Close'
                     && ( login_user_name === ftie_page_obj.gro_owner ||  login_user_name === 'power')"
                     style="margin-left: 5px;">
                  <b-form-checkbox v-model="ticketOpen"
                                   name="check-button"
                                   @change="showSaCloseTicket(_.get(ftie_page_obj, 'ftie_id', ''))"
                                   switch>
                    <p style="color:#F77530">Switch left to <b>close</b> ticket </p>
                  </b-form-checkbox>
                </div>
                <div v-if="ftie_page_obj !== null && ftie_page_obj.request_from &&  _.get(ftie_page_obj, 'status', '') === 'Close'  && ( login_user_name === ftie_page_obj.gro_owner ||  login_user_name === 'power')"
                     style="margin-left: 5px;">
                  <b-button class="ml-2" size="sm" variant="primary" @click="reopenSubTicket()">
                    re-open
                  </b-button>
                </div>
                <b-modal centered ok-title="Close" @ok="closeMasterTicket"
                         cancel-title="Cancel"
                         ok-variant="danger"
                         ref="SaCloseMasterTicketModal" :title="`Close FTIE#${_.get(ftie_page_obj, 'ftie_id', '')}`"
                         button-size="sm">

                  <div class="row">
                    <div class="col-auto">
                      <div class="label mt-2">Close Reason:</div>
                    </div>
                    <div class="col-auto" style="width: 300px;">
                      <gtc-textarea v-model="closeMasterTicketReason" />
                    </div>
                    <div :class="[classObject(closeMasterTicketReason, 255)]" style="padding-left: 162px;">
                      <span>You've input: {{ closeMasterTicketReason | getInputLength }}/255</span>
                    </div>
                  </div>
                </b-modal>

                <!-- End Region ---- TODO: CLOSE TICKET -->

              </div>

            </div>
            <div class="col-4">
              <div class="header-col">
                <div>Salesforce Opportunity</div>
                <div v-if="ftie_page_obj != null && ifShowOptyLink(ftie_page_obj.site)">
                  <gtc-opportunity v-if="ftie_page_obj != null" :opportunityId="ftie_page_obj.salesforce_opty_id"
                                   :opportunityName="ftie_page_obj.salesforce_opty_name" />
                </div>
                <div v-else>
                  <a class="link" target="_blank" :href="safeUrl(`${ $root.salesforceUrl }/${ ftie_page_obj.salesforce_opty_id }`)">{{ _.get(ftie_page_obj, 'salesforce_opty_name', '') }}</a>
                </div>

              </div>
              <div class="header-col">
                <div>Escalate Date</div>
                <div>{{ _.get(ftie_page_obj, 'escalated_date', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Due Date</div>
                <div>{{ _.get(ftie_page_obj, 'assign_date', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Contact Sales</div>
                <div>{{ _.get(ftie_page_obj, 'contact_sales', '') }}</div>
              </div>
              <div class="header-col">
                <div>GRO Owner</div>
                <div>{{ _.get(ftie_page_obj, 'gro_owner', '')  }}</div>
                <button v-if="(ftie_page_obj !== null
                        && _.get(ftie_page_obj, 'salesforce_es_id', '') !== null
                        && _.get(ftie_page_obj, 'salesforce_es_id', '') !== '')
                        && (checkAssignerPermission() || checkTransferL1Permission())"
                        type="button"
                        class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                        v-b-tooltip.hover.right title="Transfer Ticket"
                        @click="showReAssignTicketModal()">
                </button>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col">
                <div>GRO</div>
                <div>{{ _.get(ftie_page_obj, 'site', '')  }}</div>
              </div>
              <div class="header-col">
                <div>Customer</div>
                <!-- <div>{{ _.get(ftie_page_obj, 'customer', '') }}</div> -->
                <div v-if="ftie_page_obj != null && ifShowOptyLink(ftie_page_obj.site)">
                  <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${_.get(ftie_page_obj, 'salesforce_account_id', '') }`)">{{ _.get(ftie_page_obj, 'customer', '') }}</a>
                </div>
                <div v-else>
                  <a class="link" target="_blank" :href="safeUrl(`${ $root.salesforceUrl }/${ ftie_page_obj.salesforce_account_id }`)">{{ _.get(ftie_page_obj, 'customer', '') }}</a>
                </div>
              </div>
              <div class="header-col">
                <div>Vertical</div>
                <div>{{ _.get(ftie_page_obj, 'vertical', '')  }}</div>
              </div>
              <div class="header-col">
                <div>Type</div>
                <div v-if="_.get(ftie_page_obj, 'type', '') === 'ETO Sector SKU'"
                     style="color: #f77530;font-weight: bold;">
                  {{ _.get(ftie_page_obj, 'type', '')  }}
                </div>
                <div v-else>
                  {{ _.get(ftie_page_obj, 'type', '')  }}
                </div>
              </div>
              <div class="header-col">
                <div>Sales Director/Manager</div>
                <div>{{ _.get(sales_director, 'member_gulid', '')  }}</div>
                <button v-if="sales_director != null " class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" style="margin-top: -4px;"
                        v-b-tooltip.hover.topright :title="sales_director.member_depart"></button>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col">
                <div>Close Reason</div>
                <div>{{ _.get(ftie_page_obj, 'close_reason', '') }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col">
                <div>GTC Owner</div>
                <div>{{ _.get(ftie_page_obj, 'gtc_owner', '')  }}</div>
                <button v-if="checkAssignerPermission()"
                        type="button"
                        class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                        v-b-tooltip.hover.right title="Re-assign"
                        @click="showReAssignTicketModal()">
                </button>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col" v-if="ftie_page_obj.type==='Customization Support'">
                <div>Tracking Unique PN ?</div>
                <div>
                  {{ _.get(ftie_page_obj, 'need_unique_pn_flag', true)? 'Need' : 'Not need'  }}
                </div>
                <b-form-checkbox class="ml-3" v-model="ftie_page_obj.need_unique_pn_flag"
                                 name="check-button" @change="updatePnNeedFlag"
                                 switch>
                </b-form-checkbox>
              </div>
            </div>
            <div class="col-4" v-if="ftie_page_obj.type==='Customization Support'">
              <div class="header-col">
                <div class="d-inline-block">
                   Tracking Stage <i v-if="tracking_data_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                </div>
                <div>{{ _.get(ftie_page_obj, 'tracking_stage', '') }}</div>
              </div>
            </div>
            <div class="col-4" v-if="ftie_page_obj.type==='Customization Support'">
              <div class="header-col">
                <div class="d-inline-block "> Tracking Status <i v-if="tracking_data_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"></i></div>
                <div>{{ _.get(ftie_page_obj, 'tracking_status', '')  }}</div>
              </div>
            </div>
            <div class="col-4" v-if="ftie_page_obj.type==='Customization Support'">
              <div class="header-col">
                <div class="d-inline-block ">Action Required By <i v-if="tracking_data_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"></i></div>
                <div>{{ _.get(ftie_page_obj, 'tracking_owner', '')  }}</div>
              </div>
            </div>
            <!-- migrate to new section: Ticket description
    <div class="col-12 h5 font-weight-bold">
    <div>Description</div>
  </div>
        <div class="col-12">
        <div class="header-col">
          <div class="h2">Issue/Requirement</div>
        -->
            <!--<div v-if="ftie_page_obj!=null" v-html="safeHtml(ftie_page_obj.issue_req)"></div>-->
            <!--
    <div class="col-6">
      <div class="header-col">
        <div>Technical Request</div>
        <div v-if="ftie_page_obj!=null" v-html="safeHtml(ftie_page_obj.description)"></div>

      </div>
  </div>-->
            <!-- es attachment move to description section
      <div v-if="ftie_page_obj !== null && (login_user_name === ftie_page_obj.gtc_owner
       || login_user_name === ftie_page_obj.gro_owner
       || login_user_name ==='power'
       || (userRoles !== null && userRoles.includes('Admin')))" class="col-12">
    <div class="header-col">
      <div>Escalation Attachment</div>
      <div>
        <div v-for="escalation_file in ftie_page_obj.escalation_files">
          <a v-if="escalation_file.file_path.includes('?file=')" class="link" @click="getSfEsAttachment(escalation_file)">{{ escalation_file.file_name }}</a>
          <a v-else class="link" @click="downloadAttachment(escalation_file.file_name, escalation_file.origin_file_name )">{{ escalation_file.origin_file_name }}</a>

          <br>
        </div>
        <div v-for="es_attachment in ftie_page_obj.es_attachment_list">
          <a class="link" @click="downloadSfEsAttachment(es_attachment.ATTACHMENT_ID, es_attachment.FILE_NAME)">{{ es_attachment.FILE_NAME }}</a>
          <br>
        </div>
      </div>
    </div>
  </div>
  -->


            <div v-if="userSites.includes('Getac') && ftie_page_obj != null && ftie_page_obj.champion_comments!=null " class="col-12">
              <div class="header-col">
                <div>Champion Comment</div>
                <div class="text-danger">{{ _.get(ftie_page_obj, 'champion_comments', '') }}</div>
              </div>
            </div>
            <div v-if="userSites.includes('Getac') && ftie_page_obj!=null && ftie_page_obj.keyword!=null" class="col-12">
              <div class="header-col">
                <div>Keyword</div>
                <div class="text-danger">{{ _.get(ftie_page_obj, 'keyword', '') }}</div>
              </div>
            </div>

          </div>

          <div class="caption-label">Ticket Description</div>
          <div class="row mb-4">
            <div class="col-6">
              <div class="header-col">
                <div>Technical Request</div>
                <div v-if="ftie_page_obj!=null" v-html="safeHtml(ftie_page_obj.description)"></div>
                <!-- <div v-html="computed_techinal_request"></div> -->

              </div>
            </div>
            <div class="col-6">
              <div class="header-col">
                <div>Customization Request</div>
                <div v-html="computed_customization_request"></div>
              </div>
            </div>
            <div class="col-6">
              <div class="header-col">
                <div>Impact</div>
                <div>{{ _.get(es_main_es_info, 'tech_info.impact', '') }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="header-col">
                <div>User Scenario</div>
                <div>{{ _.get(es_main_es_info, 'tech_info.user_scenario', '') }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="header-col">
                <div>Environment</div>
                <div>{{ _.get(es_main_es_info, 'sector_solution_info.environment', '') }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="header-col">
                <div>Pain Point</div>
                <div>{{ _.get(es_main_es_info, 'sector_solution_info.pain_point', '') }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="header-col">
                <div>Behavior</div>
                <div>{{ _.get(es_main_es_info, 'sector_solution_info.behavior', '') }}</div>
              </div>
            </div>
            <div v-if="ftie_page_obj !== null &&
                 ((login_user_name === ftie_page_obj.gtc_owner
                 || login_user_name === ftie_page_obj.gro_owner
                 || login_user_name ==='power')
                 || (userFunctions !== null && userFunctions.includes('Customer Success Manager'))
                 || (userRoles !== null && userRoles.includes('Admin')))"
                 class="col-12">
              <div class="header-col">
                <div>Escalation Attachment</div>
                <div>
                  <div v-for="escalation_file in ftie_page_obj.escalation_files">
                    <a v-if="escalation_file.file_path.includes('?file=')" class="link" @click="getSfEsAttachment(escalation_file)">{{ escalation_file.file_name }}</a>
                    <a v-else class="link" @click="downloadAttachment(escalation_file.file_name, escalation_file.origin_file_name )">{{ escalation_file.origin_file_name }}</a>
                    <!--<a v-if="escalation_file.file_path.includes('?file=') == false" class="link" :href="safeUrl(`${ $root.ftieTwUrl }/upload_file/${ escalation_file.file_name }`)">{{ escalation_file.origin_file_name }}</a>-->
                    <br>
                  </div>
                  <div v-for="es_attachment in ftie_page_obj.es_attachment_list">
                    <a class="link" @click="downloadSfEsAttachment(es_attachment.ATTACHMENT_ID, es_attachment.FILE_NAME)">{{ es_attachment.FILE_NAME }}</a>
                    <br>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="caption-label"> Ticket Operations</div>
          <div class="row mb-4">
            <div class="col-12">
              <b-button v-if="checkAssignerPermission() || checkTransferL1Permission()"
                        @click="showReAssignTicketModal()"
                        style="width: 9.5rem" variant="primary">Transfer Ticket</b-button>

              <b-modal centered ok-title="Transfer Ticket" @ok="assignTicket"
                       cancel-title="Cancel"
                       ok-variant="primary"
                       ref="ReAssignTicketModal" title="Transfer Ticket Owners"
                       button-size="sm">

                <div class="row" v-if="checkSiteChangePermission()">
                  <div class="col-6">
                    <div class="label mt-2">FTIE Site:</div>
                  </div>
                  <div class="col-4 mt-2">
                    <b-form-select v-model="temp_gro_site" :options="GRO_options" label="FTIE Ticket Owner:"></b-form-select>
                  </div>
                </div>

                <div class="row" v-if="(ftie_page_obj !== null
                        && _.get(ftie_page_obj, 'salesforce_es_id', '') !== null
                        && _.get(ftie_page_obj, 'salesforce_es_id', '') !== '')
                        && (checkAssignerPermission() || checkTransferL1Permission())">
                  <div class="col-6">
                    <div class="label mt-2">Ticket L1 Owner(GRO Owner):</div>
                  </div>
                  <div class="col-4 mt-2">
                    <b-form-select v-model="temp_gro_owner" :options="ticket_l1_owner_options" label="FTIE Ticket L1 Owner:"></b-form-select>
                  </div>
                </div>

                <div class="row" v-if="checkAssignerPermission()">
                  <div class="col-6">
                    <div class="label mt-2">Ticket L2 Owner(GTC Owner):</div>
                  </div>
                  <div class="col-4 mt-2">
                    <b-form-select v-model="temp_gtc_owner" :options="ticket_owner_options" label="FTIE Ticket L2 Owner:"></b-form-select>
                  </div>
                </div>
              </b-modal>

              <b-button v-if=" ( ftie_page_obj!= null && login_user_name == ftie_page_obj.gtc_owner) || login_user_name=='power'"
                        @click="showAssignSubTicketModal()"
                        style="width: 9.5rem" variant="primary">Assign Subticket</b-button>
              <b-modal centered ok-title="Assign" @ok="assignSubTicket"
                       cancel-title="Cancel"
                       ok-variant="primary"
                       ref="AssignSubTicketModal" title="Assign Sub ticket"
                       button-size="sm">

                <div class="row">
                  <div class="col-auto">
                    <div class="label mt-2">Sub Ticket Owner:</div>
                  </div>
                  <div class="col-auto">
                    <b-form-select v-model="sub_ticket_owner" :options="ticket_owner_options" label="Sub Ticket Owner:"></b-form-select>
                  </div>
                </div>
              </b-modal>
              <!--<b-button @click="redirectRequestForm()" style="width: 9.5rem" variant="primary">RequestForm/NRE </b-button>-->
              <a v-if="ftie_page_obj !== null && ( login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power'
    || managerAccessFtie() )  && _.get(es_main_es_info, 'sfdc_issue_type', null)==='ISV'"
                 class="btn btn-primary"
                 style="width: 12.5rem"
                 target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }nre/customization-nre-pn/${ ftie_page_obj.ftie_id }/${ ftie_page_obj.request_detail_id }/0`)">ISV NRE</a>
              <a v-if="ftie_page_obj !== null && ( login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power'|| managerAccessFtie() || (userSites && userSites.includes('Getac') && userFunctions && _.indexOf(userFunctions, 'Tech Leader') > -1))  && (ftie_page_obj.type==='Customization Support' || ftie_page_obj.type==='ETO Sector SKU')"
                 class="btn btn-primary"
                 style="width: 12.5rem"
                 target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }ftie/request-form/${ ftie_page_obj.ftie_id }`)">RequestForm/NRE/PN</a>
              <a v-if="ftie_page_obj !== null && ftie_page_obj.nre_exist === true"
                 class="btn btn-primary"
                 style="width: 9.5rem"
                 target="_blank"
                 :href="safeUrl(`${ $root.frontEndUrl }/dashboard/${ ftie_page_obj.ftie_id }`)">ETO</a>
              <b-button v-if="login_user_name=='power' || (userRoles && _.indexOf(userRoles, 'Admin') > -1)" @click="showChampionModal()" style="width: 9.5rem" variant="primary">Champion</b-button>
              <b-modal centered ok-title="Update" @ok="saveChampionComment"
                       cancel-title="Cancel"
                       ok-variant="primary"
                       no-close-on-backdrop
                       ref="ChampionModal" title="Champion Comment"
                       button-size="sm">

                <div class="row">
                  <div class="col-auto">
                    <div class="label mt-2">Champion Comment:</div>
                  </div>
                  <div class="col-auto">
                    <gtc-textarea :read-only="false" v-if="ftie_page_obj != null" v-model="ftie_page_obj.champion_comments" />
                  </div>
                </div>
              </b-modal>
              <b-button v-if="login_user_name=='power' || (userRoles && _.indexOf(userRoles, 'Admin') > -1)" @click="showKeywordModal()" style="width: 9.5rem" variant="primary">Keyword</b-button>
              <b-modal centered ok-title="Update" @ok="saveKeyword"
                       cancel-title="Cancel"
                       ok-variant="primary"
                       no-close-on-backdrop
                       ref="KeywordModal" title="Keyword"
                       button-size="sm">

                <div class="row">
                  <div class="col-auto">
                    <div class="label mt-2">Keyword:</div>
                  </div>
                  <div class="col-auto">
                    <gtc-textarea :read-only="false" v-if="ftie_page_obj != null " v-model="ftie_page_obj.keyword" />
                  </div>
                </div>
              </b-modal>
              <b-button v-if="login_user_name=='power' || (userRoles && _.indexOf(userRoles, 'Admin') > -1)"
                        @click="showReasonModal()" style="width: 9.5rem" variant="primary">ES Labeling</b-button>
              <b-modal centered ok-title="Update" @ok="saveRequestReason"
                       cancel-title="Cancel"
                       ok-variant="primary"
                       no-close-on-backdrop
                       ref="ReasonModal" title="Reason"
                       button-size="md">

                <div class="row">
                  <div class="col-4">
                    <div class="label mt-2">ES Type:</div>
                  </div>
                  <div class="col-auto">
                    <b-form-select v-model="es_category1.reason_result" :options="reason_category_options" label="ES_Category:"></b-form-select>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-4">
                    <div class="label mt-2">ES Requirement:</div>
                  </div>
                  <div class="col-8">
                    <gtc-textarea style="height: 160px;" :read-only="false" v-model="es_category2.reason_result" />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-4">
                    <div class="label mt-2">ES Category:</div>
                  </div>
                  <div class="col-8">
                    <gtc-textarea style="height: 120px;" :read-only="false" v-model="es_category3.reason_result" />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-4">
                    <div class="label mt-2">ES Module:</div>
                  </div>
                  <div class="col-8">
                    <gtc-textarea style="height: 120px;" :read-only="false" v-model="es_solution.reason_result" />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-4">
                    <div class="label mt-2">ES Key Account/Solution:</div>
                  </div>
                  <div class="col-8">
                    <gtc-textarea :read-only="false" style="height: 120px;"  v-model="es_key_account.reason_result" />
                  </div>
                </div>
              </b-modal>


            </div>
          </div>

          <div class="caption-label"
               v-if="triggerAutomationPermission('Automate NRE') || (!prdEnv() && (login_user_name === 'power' || userRoles && _.indexOf(userRoles, 'Admin') > -1))">
            Automations and AI
          </div>
          <div class="row mb-4" v-if="ftie_page_obj !== null && _.get(es_main_es_info, 'sfdc_issue_type', null) !=='ISV'">
            <div class="col-12">
              <div class="d-flex">
                <auto-nre-trigger v-if="ftie_page_obj !==null && triggerAutomationPermission('Automate NRE')"
                                  class="ml-1"
                                  :prop_sfdcProducts="sfdcProducts"
                                  :prop_user="login_user_name"
                                  :prop_ftie_id="ftie_page_obj.ftie_id"
                                  :prop_detail_id="ftie_page_obj.request_detail_id"
                                  :prop_model_name="ftie_page_obj.device"
                                  :prop_site="ftie_page_obj.site"
                                  :prop_es_info="es_main_es_info" />
                <auto-pn-trigger v-if="ftie_page_obj !==null && triggerAutomationPermission('Automate PN')"
                                 class="ml-1"
                                 @done="getAutoPnRequests"
                                 :prop_sfdcProducts="sfdcProducts"
                                 :prop_user="login_user_name"
                                 :prop_ftie_id="ftie_page_obj.ftie_id"
                                 :prop_detail_id="ftie_page_obj.request_detail_id"
                                 :prop_model_name="ftie_page_obj.device"
                                 :prop_customer_name="ftie_page_obj.customer" />


              </div>
            </div>
          </div>



        </b-tab>
        <b-tab v-if="ftie_page_obj !=null && ftie_page_obj.salesforce_es_id!=null && (userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || login_user_name == ftie_page_obj.gro_owner)"
               title="Engineering Service Info" @click="getSfEsOptyInfo">
          <div class="caption-label">Engineering Service Info</div>
          <es-info-tab v-if="sf_es_info !== null && sf_opty_info !== null && es_main_es_info !== null"
                       :prop_es_main_info_obj="es_main_es_info"
                       :prop_es_info_obj="sf_es_info"
                       :prop_sf_opty_info_obj="sf_opty_info"
                       :prop_basic_info="basicInfo"
                       :prop_user="login_user_name"
                       :prop_user_sites="userSites"
                       :prop_site="ftie_page_obj.site"/>

        </b-tab>
        <b-tab v-if="ftie_page_obj !=null && ftie_page_obj.salesforce_opty_id != null && (userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || login_user_name == ftie_page_obj.gro_owner)" title="Opportunity Info" @click="getSfEsOptyInfo">
          <div class="caption-label">Opportunity Info</div>
          <div class="row mb-4">
            <div class="col-4">
              <div class="header-col">
                <div>ES ID (link to SFDC)</div>
                <gtc-account-link v-if="es_main_es_info !== null && _.get(es_main_es_info, 'opty_obj_id', null) != null"
                                 :opportunityId="_.get(es_main_es_info, 'opty_obj_id', null)"
                                 :opportunityName="_.get(es_main_es_info, 'es_id', null)" />
              </div>
              <div class="header-col">
                <div>Vertical Industry</div>
                <div>{{ _.get(sf_opty_info, 'VERTICAL_INDUSTRY__C', '') }} </div>
              </div>
              <div class="header-col">
                <div>RSM Territory</div>
                <div>{{ _.get(sf_opty_info, 'RSM_TERRITORY_DEL__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>Unit Qty</div>
                <div>{{ _.get(sf_opty_info, 'TOTALOPPORTUNITYQUANTITY', '') }}</div>
              </div>
              <div class="header-col">
                <div>Amount</div>
                <div>{{ _.get(sf_opty_info, 'AMOUNT', '') }}</div>
              </div>
              <div class="header-col">
                <div>Stage</div>
                <div>{{ _.get(sf_opty_info, 'STAGE', '') }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col-mid">
                <div>Probability (%)</div>
                <div>{{ _.get(sf_opty_info, 'PROBABILITY', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>Technical Stage</div>
                <div>{{ _.get(sf_opty_info, 'TECHNICAL_STAGE', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>Primary Campaign Source</div>
                <div>{{ _.get(sf_opty_info, 'CAMPAIGN_SOURCE', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>User Group</div>
                <div>{{ _.get(sf_opty_info, 'USER_GROUP', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>System Quantity</div>
                <div>{{ _.get(sf_opty_info, 'SYSTEM_QUANTITY', '') }}</div>
              </div>
            </div>
            <div class="col-4">

              <!--<div class="header-col">
          <div>US State / Canadian Province</div>
          <div>{{ _.get(ftie_page_obj, 'sf_es_info.PRESALES_CONFIGURATION__C', '')  }}</div>
        </div>-->


              <div class="header-col">
                <div>Country</div>
                <div>{{ _.get(sf_opty_info, 'COUNTRY__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>Opportunity Currency</div>
                <div>{{_.get(sf_opty_info, 'OPPORTUNITY_CURRENCY', '') }}</div>
              </div>
              <div class="header-col">
                <div>Lead Source</div>
                <div>{{ _.get(sf_opty_info, 'LEAD_SOURCE', '') }}</div>
              </div>
              <div class="header-col">
                <div>Registration Date</div>
                <div>{{ _.get(sf_opty_info, 'REGISTRATION_DATE', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Decision Date</div>
                <div>{{ _.get(sf_opty_info, 'DECISION_DATE', '') | dateTimeFormat}}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Customer Comments</div>
                <div>{{ _.get(sf_opty_info, 'CUSTOMER_COMMENTS', '') }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Latest Update Info</div>
                <div v-if="sf_opty_info != null" v-html="sf_opty_info.LATEST_UPDATE_INFORMATION"></div>
              </div>
            </div>

          </div>
        </b-tab>

        <b-tab v-if="checkETOSectorVisibility()"
               title="ETO Sector SKU Info"
               @click="getEtoSectorSkuInfo">
          <eto-sector-sku v-if="etoSectorSkus"
                          :prop_eto_sector_sku_info="etoSectorSkus"
                          :prop_page_obj="ftie_page_obj"
                          :prop_user="login_user_name" />
        </b-tab>
        <b-tab v-if="ftie_page_obj !==null && ftie_page_obj.sub_tickets.length !==0 && (userSites.includes('Getac') || login_user_name === ftie_page_obj.gtc_owner)" title="Sub Tickets">
          <div class="table-responsive mt-2" style="min-height: 2.5rem">
            <b-table v-if="ftie_page_obj !==null && ftie_page_obj.sub_tickets.length !==0 && (userSites.includes('Getac') || login_user_name === ftie_page_obj.gtc_owner)"
                     :fields="subTicketsTableFileds" :items="ftie_page_obj.sub_tickets"
                     small
                     ref="selectableTable"
                     selectable
                     select-mode="single"
                     thead-class="thead-light text-dark"
                     style="width: calc(100% - 10px)">
              <template #cell(ftie_id)="data">
                <a class="link" target="_blank" :href="safeUrl(`${frontEndUrlToUse}ftie/ftie-page/${ data.item.ftie_id }`)">{{ data.item.ftie_id }}</a>
              </template>
              <template #cell(action)="data">
                <button v-if="data.item.status!=='Close' && ftie_page_obj!= null && (login_user_name == ftie_page_obj.gtc_owner|| login_user_name=='power')" type="button" class="btn btn-danger" @click="showCloseSubTicketModal(data.item.ftie_id)">Close</button>
              </template>
            </b-table>

            <b-modal centered ok-title="Close" @ok="closeSubTicket"
                     cancel-title="Cancel"
                     ok-variant="danger"
                     ref="CloseSubTicketModal" :title="`FTIE#${closeSubTicketFTIE} Close`"
                     button-size="sm">

              <div class="row">
                <div class="col-auto">
                  <div class="label mt-2">Close Reason:</div>
                </div>
                <div class="col-auto">
                  <gtc-textarea v-model="closeSubTicketReason" />
                </div>
              </div>
            </b-modal>
          </div>
        </b-tab>
        <b-tab v-if="ftie_page_obj !=null && editSubjectPermisson()"
               title="Assess and Analyse"
               @click="getTicketAssessInfo">
          <gtc-ftie-tag v-if="ticketAssessInfo"
                        :prop_assess_info="ticketAssessInfo"
                        :prop_page_obj="ftie_page_obj"
                        :prop_user="login_user_name" />
        </b-tab>
        <b-tab v-if="ftie_page_obj !=null && (login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles!== null && userRoles.includes('Admin')))"
               title="Kickoff Files"
               @click="getFtieKickoffFiles">
          <nre-kickoff-files v-if="kickoff_files!=null" :prop_kickoff_files="kickoff_files"></nre-kickoff-files>
        </b-tab>
        <b-tab  title="Customization Tracking" v-if="ftie_page_obj !=null && (login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles!== null && userRoles.includes('Admin')))" @click="getTrackingData">
          <cust-tracking :prop_mail_loop="ftie_page_obj.mail_loop" :prop_ftie_id="ftie_page_obj.ftie_id" ref="custTracking"
                         :prop_detail_id="ftie_page_obj.request_detail_id" :prop_user_name="login_user_name"
                         :prop_gro_owner="ftie_page_obj.gro_owner" :prop_permission="tracking_edit_permission" @refresh-parent="refreshChatroom" ></cust-tracking>
        </b-tab>
      </b-tabs>
    </div>

    <div class="stage-header border-bottom mb-4">

      <div v-if="similarityResult !== null && !prdEnv()">
        <b-alert v-if="similarityResult !== null" show dismissible>
          Recommend by AI:
          <div v-for="(val, key) in similarityResult">
            <div v-if="similarityResult[key].ftie_id !== ftie_page_obj.ftie_id">
              <a class="link"
                 target="_blank"
                 :href="safeUrl(`${frontEndUrlToUse}ftie/ftie-page/${ similarityResult[key].ftie_id }`)">
                {{ similarityResult[key].ftie_id }}
              </a>:{{similarityResult[key].score}}
            </div>
          </div>
          Click the close button over there <b>&rArr;</b>
        </b-alert>
      </div>
      <!-- region: SKU PN Loader -->
      <div style="padding-left: 17px;" v-if="skuPnDisplayed">
        <div class="d-flex">
          <b-button block v-b-toggle.collapse1
                    variant="light"
                    class="text-primary text-left"
                    style="background-color: white; border: none; width: 9.5rem;">
            <div class="d-inline-block ">
              SKU PN
              <b-icon :icon="isCollapsed ? 'chevron-down' : 'chevron-up'"></b-icon>
              <i v-if="sfdc_prd_line_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </div>
          </b-button>
          <div class="text-danger pt-1 h4" v-if="ftie_page_obj.need_unique_pn_flag === true && without_unique_pn ===true">
            Waiting for Unique PN to be synced
          </div>
        </div>


        <div>
          <b-alert v-if="!sfdc_prd_line_loading" show dismissible variant="primary">
            Click above SKU PN <b-icon :icon="isCollapsed ? 'chevron-down' : 'chevron-up'"></b-icon> to expand the <b>Salesforce products and customization PN </b>sync details.
          </b-alert>
        </div>

        <b-collapse id="collapse1" @shown="onShown" @hidden="onHidden" accordion="SFDC Product Line" role="tabpanel">
          <sfdc-prd-line v-if="sfdcProducts!=null"
                         :prop_sfdc_page_obj="sfdcProducts"
                         :prop_basic_info="basicInfo"
                         :prop_user="login_user_name"
                         :prop_user_sites="userSites" @refreshPrdLine="getSfProductline(false)"
                         :prop_request_detail_id="ftie_page_obj.request_detail_id" />
          <div class="caption-label">Auto PN request</div>
          <div class="table-responsive mt-2" v-if="ftie_page_obj !==null && triggerAutomationPermission('Automate PN')">
            <b-table :items="autopn_items" :fields="autoPnFields" thead-class="thead-light text-dark" small>
            </b-table>
          </div>
        </b-collapse>
      </div>
      <!-- endregion -->
      <div class="stage-header border-bottom mb-4">
        <br />
      </div>

      <div class="caption-label" style="padding-left: 17px;">
        Subject List
        <div class="ml-3 mb-1 d-print-none">
          <b-button v-if="inMailGroup" v-b-modal.add-subject class="btn btn-primary btn-sm min-w-4" variant="primary">New</b-button>
          <b-button v-if="userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || login_user_name === ftie_page_obj.gtc_owner || login_user_name === ftie_page_obj.gro_owner" v-b-modal.display-related-attachments class="btn btn-primary btn-sm min-w-4" variant="primary">View All Attachments</b-button>
          <b-modal centered id="add-subject" title="Add Subject" ok-title="Add" @ok="subjectLengthValidate($event) && handleSubjectOk()" @show="resetModal" @hidden="resetModal">
            <div class="header-col validate">
              Please use the options below to troubleshoot your question.
            </div>
            <b-row class="mt-2">
              <b-col sm="2">
                <label for="textarea-subject">Category<span class="text-danger pl-1">*</span></label>
              </b-col>
              <b-col sm="1">
                :
              </b-col>
              <b-col sm="9">
                <b-form-select size="sm"
                               v-model="temp_subject.subject_category"
                               :options="subjectCategoryOptions"
                               @change="setSubjectDefaultContext()"
                               required>
                </b-form-select>
              </b-col>
            </b-row>
            <div class="border-bottom" style="margin-top: 20px; margin-bottom: 20px;"></div>
            <b-row class="mt-2">
              <b-col sm="2">
                <label for="textarea-subject">Subject<span class="text-danger pl-1">*</span></label>
              </b-col>
              <b-col sm="1">
                :
              </b-col>
              <b-col sm="9">
                <div v-if="temp_subject.subject_category !== null && temp_subject.subject_category !== ''">
                  <b-form-textarea id="textarea-subject" required v-model="temp_subject.subject" placeholder="Write a subject" rows="1"></b-form-textarea>
                  <div :class="[classObject(_.get(temp_subject, 'subject', ''), 1000)]">
                    <span>You've input: {{ _.get(temp_subject, 'subject', '') | getInputLength }}/1000</span>
                  </div>
                </div>
                <div v-else>
                  <span class="text-danger pl-1">Please choose the category first!</span>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="2">
                <label for="textarea-description">Description</label>
              </b-col>
              <b-col sm="1">
                :
              </b-col>
              <b-col sm="9">
                <b-form-textarea id="textarea-description" v-model="temp_subject.description" placeholder="Describe more about this subject" rows="8"></b-form-textarea>
                <div :class="[classObject(_.get(temp_subject, 'description', ''), 1000)]">
                  <span>You've input: {{ _.get(temp_subject, 'description', '') | getInputLength }}/1000</span>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-2">
              <b-col sm="2"></b-col>
              <b-col sm="1"></b-col>
              <b-col sm="9">Size must be less than 15 MB</b-col>
              <b-col sm="2"></b-col>
              <b-col sm="1"></b-col>
              <b-col sm="9">
                <!--<input ref="subjectFile" type="file" class="d-none" v-on:change="handleSubjectFileUpload()" multiple>
    <b-button style="width: 9rem" variant="primary" @click="$refs.subjectFile.click()">Add Attachment</b-button>-->
                <b-form-file ref="subjectFile" v-model="filesAccumulatedTemp" multiple="true"
                             placeholder="Please select or drop file..."
                             drop-placeholder="Drop your file here..."></b-form-file>
              </b-col>

            </b-row>

            <b-row v-for="(thisFile, index) in filesAccumulated" :key=index>
              <b-col sm="2"></b-col>
              <b-col sm="1">
                <label class="btn btn-svg gtc-icon-aaron-attach"></label>
              </b-col>
              <b-col sm="6" class="mt-1">
                {{ filesAccumulated[index].name }}
              </b-col>
              <b-col sm="1">
                <label class="btn btn-svg gtc-icon-aaron-cancel mt-1" @click="deleteTempFile($event, index)"></label>
              </b-col>
            </b-row>
          </b-modal>

          <b-modal centered ref="display-related-attachments-modal" id="display-related-attachments" title="Attachments Append on the Ticket Subject" ok-title="Ok">
            <b-table v-if='ftie_page_obj.all_chatroom_attachments !== null && ftie_page_obj.all_chatroom_attachments.length>0' small thead-class="thead-light text-dark"
                     :items="ftie_page_obj.all_chatroom_attachments" :fields="chatroomAttachmentSetting">
              <template #cell(FILE_NAME)="data">
                {{data.item.OLD_FILE_NAME}}
              </template>
              <template #cell(ACTION)="data">
                <!--<a v-if="_.trim(data.item.FILE_NAME) !== ''" class="file" herf="#" @click="downloadAttachment(data.item.FILE_NAME, data.item.OLD_FILE_NAME )"> download</a>-->
                <!--<a v-if="_.trim(data.item.FILE_NAME) !== ''" class="file" herf="#" @click="selectCertainSubject(data.item.SUBJECT_ID)"> jump to</a>-->
                <!--<a v-if="_.trim(data.item.FILE_NAME) !== ''" class="file" herf="#" @click="selectCertainSubject(data.item.SUBJECT_ID)"> <b-icon v-if="_.trim(data.item.FILE_NAME) !== ''" icon="search" @click="selectCertainSubject(data.item.SUBJECT_ID)"></b-icon>jump to</a>-->
                <button :id="`attach-button-${data.index}`" type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-more"></button>
                <b-popover :target="`attach-button-${data.index}`" custom-class="menu" triggers="focus">
                  <div class="list-group list-group-flush">
                    <button type="button" class="px-2 py-1 list-group-item list-group-item-action" @click="downloadAttachment(data.item.FILE_NAME, data.item.OLD_FILE_NAME )">Download File</button>
                    <button type="button" class="px-2 py-1 list-group-item list-group-item-action" @click="selectCertainSubject(data.item.SUBJECT_ID)">Jump to Reply</button>
                  </div>
                </b-popover>
              </template>
            </b-table>
            <div v-else>
              No Attachments
            </div>
          </b-modal>
        </div>
      </div>
      <!-- Region: proposal approval -->
      <br />
      <div style="padding-left: 33px;">
        <b-row>
          <b-col cols="2" class="label">
            Proposal Abstract:
          </b-col>
          <b-col style="margin-left: -60px;"> Proposal-type topics will be summarized into this section for review and approval. </b-col>
        </b-row>
      </div>
      <div class="table-responsive mt-2"
           style="min-height: 2.5rem; padding-left: 33px"
           v-if="ftie_page_obj !== null && ftie_page_obj.solution_comments !== null && ftie_page_obj.proposal_solutions !== null &&  ftie_page_obj.proposal_solutions.length>0">
        <b-table :fields="proposalFields"
                 :items="ftie_page_obj.proposal_solutions"
                 small
                 thead-class="thead-light text-dark"
                 style="width: calc(100% - 10px)">
          <template #cell(status_icon)="data">
            <div v-if="data.item !== null && data.item.approval_status === 'Approved'">
              <b-icon icon="check-circle-fill" variant="success"></b-icon>
            </div>
            <div v-if="data.item !== null && data.item.approval_status === 'Rejected'">
              <b-icon :id=" `rejected-${data.item.subject_id}`"
                      icon="x-circle-fill" variant="danger">
              </b-icon>
              <b-tooltip placement="bottom"
                         :target="`rejected-${data.item.subject_id}`"
                         noninteractive>{{_.get(data.item, 'approval_comments', 'N/A')}}</b-tooltip>
            </div>


          </template>
          <template #cell(approval_status)="data">
            <b-row class="justify-content-md-center"
                   v-if="data.item !== null && (data.item.approval_status === null ||
                   data.item.approval_status === '' ||
                   data.item.approval_status === 'Waiting')">

              Waiting {{data.item.approval_by}}'s approval
            </b-row>
            <b-row v-else class="justify-content-md-center">
              {{ data.item.approval_status}} by {{data.item.approval_by}}
              <!--
                                  <button style="margin-top: -0.2rem; margin-left: 0.2rem"
                        v-if="data.item.approval_status === 'Rejected'"
                        type="button"
                        class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                        v-b-tooltip.hover.bottom
                        :title="data.item.approval_comments">
                </button>
              -->

            </b-row>
          </template>
          <template #cell(subject_detail_info.description)="data">
            <div style="margin-left: 15px;">
              <b-row>
                <b-col cols="2">
                  <span style="font-weight:bold">
                    Subject
                  </span>:
                </b-col>
                <b-col>
                  {{data.item.subject_detail_info.subject}}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="2">
                  <span style="font-weight:bold">
                    Details
                  </span>:
                </b-col>
                <b-col>
                  <span v-html="data.item.subject_detail_info.description"></span>
                </b-col>
              </b-row>
              <b-row v-if="data.item !== null && data.item.subject_detail_info.attachments !== null && data.item.subject_detail_info.attachments.length > 0"
                     v-for="(item, key) in data.item.subject_detail_info.attachments"
                     :key="key">
                <b-col cols="2">
                  <span style="font-weight:bold">Attachement</span>:
                </b-col>
                <b-col>
                  <a v-if="userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || _.find(ftie_page_obj.mail_loop, { member_gulid: item.createby, role:'GTC Owner' }) != null"
                     class="link"
                     @click="downloadAttachment(item.file_name, item.old_file_name )">{{ item.old_file_name }}</a>
                </b-col>
              </b-row>

              <b-row v-if="data.item !== null && _.get(data.item, 'approval_status', null) === 'Rejected'">
                <b-col cols="2">
                  <span class="text-danger" style="font-weight:bold">Comment</span>:
                </b-col>
                <b-col>
                  <span class="text-danger">
                    {{_.get(data.item, 'approval_comments', 'N/A')}}
                  </span>
                </b-col>
              </b-row>


            </div>
          </template>
          <template #cell(create_date)="data">
            <b-row class="justify-content-md-center">{{ data.item.create_by }}</b-row>
            <b-row class="justify-content-md-center">{{ data.item.create_date | dateTimeFormat}}</b-row>
          </template>
          <template #cell(approval_date)="data">
            <b-row class="justify-content-md-center">{{ data.item.approval_by }}</b-row>
            <b-row class="justify-content-md-center">{{ data.item.approval_date | dateTimeFormat}}</b-row>
          </template>
          <template #cell(actions)="data">
            <!-- v-if="data.item.approval_status === null
            || data.item.approval_status === ''
            || data.item.approval_status === 'Waiting'" -->
            <div v-if="approveProposalPermission() && (data.item.approval_status === null
                 || data.item.approval_status === ''
                 || data.item.approval_status === 'Waiting')"
                 style="display: inline-block; min-width: 4rem">
              <b-button size="sm" variant="success" class="mb-2"
                        @click="proposalApprovalModal(data.item, 'approve')"
                        v-b-tooltip.hover.left title="Approve this proposal">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button size="sm" variant="danger" class="mb-2"
                        @click="proposalApprovalModal(data.item, 'reject')"
                        v-b-tooltip.hover.left title="Reject this proposal">
                <b-icon icon="x-circle-fill"></b-icon>
              </b-button>
              <b-modal centered ok-title="Yes, I Approve "
                       @ok="proposalOperations(proposalToApprove, 'approve')"
                       cancel-title="No, I Don't "
                       ok-variant="primary"
                       :id="'modal-approve-proposal-'+data.item.subject_id"
                       title="Proposal Confirmation"
                       button-size="sm">
                <div class="row">
                  <div class="col">
                    Do You Want to Approve This Proposal?
                  </div>
                </div>
              </b-modal>
              <b-modal centered ok-title="Yes, I Reject "
                       @ok="proposalOperations(proposalToReject, 'reject')"
                       cancel-title="No, I Don't "
                       ok-variant="danger"
                       :id="'modal-reject-proposal-'+data.item.subject_id"
                       title="Do You Want to Reject This Proposal?"
                       button-size="sm">

                <div class="row">
                  <div class="col-auto">
                    <div class="label mt-2">Reason:</div>
                  </div>
                  <div class="col">
                    <gtc-textarea :read-only="false"
                                  v-if="proposalToReject !== null"
                                  v-model="proposalToReject.approval_comments" />
                  </div>
                </div>
              </b-modal>
            </div>
            <div v-else>
              <!-- hide action button (approve/reject)-->
            </div>
          </template>
        </b-table>
      </div>
      <div v-else style="padding-left: 33px">
        <b-alert show variant="primary">
          There is no proposal has been provided for this ticket.
        </b-alert>
      </div>
      <!-- End Region-->
      <div class="label" style="padding-left: 33px;">
        <br>
        Subjects
      </div>

      <div class="table-responsive mt-2" style="min-height: 2.5rem; padding-left: 33px">
        <b-table hover v-if="ftie_page_obj != null && ftie_page_obj.solution_comments != null"
                 :fields="fields_chat" :items="ftie_page_obj.subjects"
                 small
                 ref="selectableTable"
                 selectable
                 select-mode="multi"
                 thead-class="thead-light text-dark"
                 style="width: calc(100% - 10px)"
                 :tbody-tr-class="commentRowClass"
                 @row-clicked="handleRowClicked">

          <template #head(expand)="data">
            <div style="display: inline-block; min-width: 4rem">
              <b-button class="btn-xs gtc-icon-plus" @click="expandAllSubject(true)"
                        v-b-tooltip.hover.left title="Expand All"></b-button>
              <b-button class="btn-xs gtc-icon-minus" @click="expandAllSubject(false)"></b-button>

            </div>

          </template>
          <template #cell(expand)="data">
            <div v-if="data.item.subject_category === 'Proposal/Solution'">
              <b-row v-if="data.item.proposal_approval_detail !== null && data.item.proposal_approval_detail.approval_status === 'Approved'"
                     class="justify-content-md-center">
                <b-icon icon="check-circle-fill" variant="success"></b-icon>
              </b-row>
              <b-row v-if="data.item.proposal_approval_detail !== null && data.item.proposal_approval_detail.approval_status === 'Rejected'"
                     class="justify-content-md-center">
                <b-icon icon="x-circle-fill" variant="danger"></b-icon>
              </b-row>
              <b-row v-if="data.item.proposal_approval_detail !== null && (data.item.proposal_approval_detail.approval_status === null || data.item.proposal_approval_detail.approval_status === 'Waiting' || data.item.proposal_approval_detail.approval_status === '')"
                     class="justify-content-md-center">
                <b-icon :id=" `waiting-approval-${data.item.subject_id}`" icon="question-circle-fill" variant="primary"></b-icon>
                <b-tooltip placement="left"
                           :target="`waiting-approval-${data.item.subject_id}`"
                           noninteractive>Waiting for approval</b-tooltip>
              </b-row>
            </div>
          </template>

          <template #cell(subject_category)="data">
            <b-row class="justify-content-md-center">
              <b-col cols="8" v-if="_.get(data.item, 'subject_category', '') > 17">
                <span>{{data.item.subject_category}}</span>
              </b-col>
              <b-col cols="8" v-else style="padding-top: 0.5rem;">
                <span>
                  {{data.item.subject_category}}
                </span>
              </b-col>
              <b-col>
                <div v-if="editSubjectPermisson()">
                  <button type="button"
                          class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                          style="margin-top: 0.5rem; margin-left: 0.02rem;"
                          @click="showEditCateogyModel(data.item)"></button>
                </div>

              </b-col>
            </b-row>
            <b-modal centered :id="'modal-category-' + data.item.subject_id" title="Edit Subject Category"
                     ok-title="Save"
                     @show="resetModal"
                     @hidden="resetModal"
                     @ok="editSubject(data.item.subject_id, temp_subject_to_edit)">
              <b-row class="mt-2">
                <b-col sm="2">
                  <label for="textarea-subject">
                    Category
                  </label>
                </b-col>
                <b-col sm="1">
                  :
                </b-col>
                <b-col sm="9">
                  <b-form-select size="sm"
                                 v-model="temp_subject_to_edit.subject_category"
                                 :options="subjectCategoryOptions"
                                 required>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-modal>
          </template>
          <template #cell(subject)="data">
            <b-row :ref="`subject_${data.item.subject_id}`" style="margin-left: 15px;" v-html="data.item.subject"></b-row>
          </template>
          <template #cell(creation_time)="data">
            <b-row class="justify-content-md-center">{{ data.item.createby }}</b-row>
            <b-row class="justify-content-md-center">{{ data.item.create_date | dateTimeFormat}}</b-row>
          </template>
          <template #cell(last_update)="data">
            <b-row class="justify-content-md-center">{{ data.item.updateby }}</b-row>
            <b-row class="justify-content-md-center">{{ data.item.update_date | dateTimeFormat}}</b-row>
          </template>
          <template #cell(comment.length)="data">
            <b-row class="justify-content-md-center">{{ data.item.comments.length }}</b-row>
          </template>
          <template #row-details="row">
            <b-card>
              <b-row class="mb-4">
                <b-col cols="6" v-html="row.item.description"></b-col>
                <div class="w-100"></div>
              </b-row>
              <b-row v-for="(item, key) in row.item.attachments" :key="key">
                <b-col class="mt-1">
                  <label class="btn btn-svg gtc-icon-aaron-attach mr-2 mt-1"></label>
                  <a v-if="userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || _.find(ftie_page_obj.mail_loop, { member_gulid: item.createby, role:'GTC Owner' }) != null"
                     class="link" @click="downloadAttachment(item.file_name, item.old_file_name )">{{ item.old_file_name }}</a>
                </b-col>
              </b-row>
            </b-card>
            <b-card v-if="row.item.comments.length != 0 && row.item._showDetails === true" style="border-bottom: none">
              <b-card v-for="(item, key) in filterParentComments(row.item.comments)" :key="key" class="ml-5" style="border-left: 2px solid  orange">
                <b-row>
                  <b-col cols="4"><label v-if="item.createby != null && item.createby!=''" class="btn btn-svg gtc-icon-aaron-man mr-2" :data-letters="item.createby.substring(0,1).toUpperCase()"></label>{{' '}}{{ item.createby }} <span class="ml-4">{{ item.create_date | dateTimeFormat}}</span></b-col>
                  <div class="w-100"></div>
                  <b-col v-html="item.content" class="ml-5"></b-col>

                </b-row>
                <b-row v-for="(attachment_item, attachment_key) in item.attachments" :key="attachment_key">
                  <b-col>
                    <label class="btn btn-svg gtc-icon-aaron-attach mr-2 mt-1"></label>
                    <a v-if="userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || _.find(ftie_page_obj.mail_loop, { member_gulid: attachment_item.createby, role:'GTC Owner' }) != null"
                       class="link" @click="downloadAttachment(attachment_item.file_name, attachment_item.old_file_name )">{{ attachment_item.old_file_name }}</a>
                  </b-col>
                </b-row>

                <b-button v-if="login_user_name == item.createby" v-b-modal="modalId(item.comment_id)" class="ml-4 mt-2">Add Attachment</b-button>
                <b-modal centered :id="'modal' + item.comment_id" title="Add Attachment" ok-title="Add" @ok="handleAttachmentOk(item.subject_id, item.comment_id)">
                  <!--<input :ref="`uploader_${item.comment_id}`" type="file" class="d-none" v-on:change="handleCommentFilesUpload(item)" multiple>-->
                  <b-form-file :ref="`uploader_${item.comment_id}`" v-model="filesAccumulatedTemp"
                               placeholder="Please select or drop file..."  multiple=true
                               drop-placeholder="Drop your file here..."></b-form-file>
                  <!--<b-button style="width: 9.5rem" variant="primary" @click="upload(item.comment_id)" class="mb-2">Upload File</b-button>-->
                  <b-row v-for="(attachments, key) in filesAccumulated" :key="key">
                    <b-col sm="1">
                      <label class="btn btn-svg gtc-icon-aaron-attach"></label>
                    </b-col>
                    <b-col sm="6" class="mt-1">
                      {{ filesAccumulated[key].name }}

                    </b-col>
                    <b-col sm="1">
                      <label class="btn btn-svg gtc-icon-aaron-cancel mt-1" @click="deleteTempFile($event, key)"></label>
                    </b-col>
                  </b-row>
                </b-modal>
                <div class="mt-4 ml-5">
                  <span :class="{'bi bi-arrow-up': item.reply_visible === true, 'bi bi-arrow-down': item.reply_visible === false, 'text-danger':
                        checkUnreadReply(row.item.comments, item.comment_id)}" @click="togglefilterReply(row.item, item)">
                    <b-icon v-if="item.reply_visible === true" icon="caret-up-fill "></b-icon>
                    <b-icon v-else icon="caret-down-fill"></b-icon>
                    {{filterReply(row.item.comments, item.comment_id).length}} reply
                  </span>
                  <span v-if="inMailGroup" @click="toggleReplyFroala(item.comment_id)" class="ml-4">Reply</span>
                </div>
                <div class="mt-4 ml-5">
                  <span v-if="item.reply_visible === true" v-for="(item_reply, key) in filterReply(row.item.comments, item.comment_id)" :key="key">
                    <b-card class="ml-4">
                      <b-row>
                        <b-col cols="5"><label class="btn btn-svg gtc-icon-aaron-man mr-2" :data-letters="item_reply.createby.substring(0,1).toUpperCase()"></label>{{' '}}{{ item_reply.createby }}<span class="ml-4">{{ item_reply.create_date | dateTimeFormat}}</span></b-col>
                        <div class="w-100"></div>
                        <b-col v-html="item_reply.content" class="ml-5"></b-col>
                      </b-row>
                      <b-row v-for="(attachment_item, attachment_key) in item_reply.attachments" :key="attachment_key">
                        <b-col>
                          <label class="btn btn-svg gtc-icon-aaron-attach mr-2 mt-1"></label>
                          <a v-if="userSites.includes(ftie_page_obj.site) || userSites.includes('Getac') || _.find(ftie_page_obj.mail_loop, { member_gulid: attachment_item.createby, role:'GTC Owner' }) != null"
                             class="link" @click="downloadAttachment(attachment_item.file_name, attachment_item.old_file_name )">{{ attachment_item.old_file_name }}</a>
                        </b-col>
                      </b-row>

                      <b-button v-if="login_user_name == item_reply.createby" v-b-modal="modalId(item_reply.comment_id)" class="ml-4 mt-2">Add Attachment</b-button>
                      <b-modal centered :id="'modal' + item_reply.comment_id" title="Add Attachment" ok-title="Add" @ok="handleAttachmentOk(item_reply.subject_id, item_reply.comment_id)" @show="resetModal" @hidden="resetModal">
                        <!--<input :ref="`uploader_${item_reply.comment_id}`" type="file" class="d-none" v-on:change="handleCommentFilesUpload(item_reply)" multiple>
  <b-button style="width: 9.5rem" variant="primary" @click="upload(item_reply.comment_id)" class="mb-2">Upload File</b-button>-->
                        <b-form-file :ref="`uploader_${item.comment_id}`" v-model="filesAccumulatedTemp"
                                     placeholder="Please select or drop file..."  multiple="true"
                                     drop-placeholder="Drop your file here..."></b-form-file>
                        <b-row v-for="(attachments, key) in filesAccumulated" :key="key">
                          <b-col sm="1">
                            <label class="btn btn-svg gtc-icon-aaron-attach"></label>
                          </b-col>
                          <b-col sm="6" class="mt-1">
                            {{ filesAccumulated[key].name }}

                          </b-col>
                          <b-col sm="1">
                            <label class="btn btn-svg gtc-icon-aaron-cancel mt-1" @click="deleteTempFile($event, key)"></label>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-card>
                  </span>
                  <!--<div class="mt-2 ml-4" v-if="inMailGroup" @click="toggleReplyFroala(item.comment_id)">
                    <span class="pl-4">Reply</span>
                  </div>-->
                  <!--<span v-if="inMailGroup" @click="toggleReplyFroala(item.comment_id)" class="mt-5 ml-4">Reply</span>-->
                  <div class="ml-4" v-if="inMailGroup && replyFroalaEditable && temp_reply.comment_id === item.comment_id">
                    <gtc-ftie-froala :read-only="false" v-model="temp_reply.content" />
                    <b-button v-if="inMailGroup" style="width: 9.5rem" @click="saveCommentReply(item, row.item)" variant="primary" class="mt-2">Send</b-button>
                  </div>
                </div>
              </b-card>
            </b-card>
            <b-card style="border-top: none">
              <div v-if="inMailGroup && froalaEditable">
                <gtc-ftie-froala :read-only="false" v-model="temp_comment.content" />
              </div>
              <b-col sm="2">
                <b-button v-if="inMailGroup" style="width: 9.5rem" @click="saveSubjectComment(row.item.subject_id, row.item)" variant="primary" class="mt-2">Send</b-button>
              </b-col>
            </b-card>
            <!--                     ref="ChatGPTResponseModal" -->

          </template>
        </b-table>
      </div>
    </div>


  </div>
</template>

<script>
  import { faL } from '@fortawesome/free-solid-svg-icons';
  /* END EXTERNAL SOURCE */
  /* BEGIN EXTERNAL SOURCE */

  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'gtc-ftie-page',
    props: {
      prop_ftie_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
    },
    data: function () {
      return {
        etoPrecheckEnable: false,
        similarityResult: null, //Extension AI Service - Similarity
        upHere: false,
        chatGptOutput: '',
        chatGptPreviousOutput: '',//previous_response
        chatGptOutputModalId: '',
        titleText: "Hello, this is ChatGPT typing ......",
        printerForOutputText: '',
        paper: '',
        paperOutput: '',
        timer: null,
        questionForChatGPT: '',
        followUpQuestionForChatGPT: '',
        enableManualType: false,
        storeConversation: false,
        hintToOpenManualType: "Function hasn't been activated, please switch to open this function",
        chosenPrompt: null,
        selectedLanguage: 'Traditional Chinese',
        languageOptions: [
          { text: 'English', value: 'English', disabled: true },
          { text: 'Traditional Chinese', value: 'Traditional Chinese' },
          { text: 'Simplified Chinese', value: 'Simplified Chinese' },
          { text: 'Japanese', value: 'Japanese' },
          { text: 'French', value: 'French' }
        ],

        default_temp_subject:
        {
          subject_id: null,
          subject: null,
          description: null,
          createby: null,
          create_date: null,
          updateby: null,
          update_date: null,
          attachments: [
          ],
          comments: [
          ]
        },
        default_temp_comment: {
          comment_id: null,
          subject_id: null,
          reply_id: null,
          content: null,
          createby: null,
          create_date: null,
          attachments: []
        },
        default_temp_attachment: {
          file_id: null,
          file_name: null
        },
        temp_comment: {
          comment_id: null,
          subject_id: null,
          reply_id: null,
          content: null,
          createby: null,
          create_date: null,
          attachment: []
        },
        temp_reply: {
          comment_id: null,
          subject_id: null,
          reply_id: null,
          content: null,
          createby: null,
          create_date: null,
          attachment: []
        },
        temp_subject: {
          subject_category: null,
          subject_id: null,
          subject: null,
          description: null,
          createby: null,
          create_date: null,
          updateby: null,
          update_date: null,
          attachment: [
          ],
          comments: [
          ]
        },
        temp_subject_to_edit: {
          subject_category: null,
          subject_id: null,
          subject: null,
          description: null,
          updateby: null,
          update_date: null,
        },
        temp_attachment: {
          file_id: null,
          file_name: null
        },
        // for comment row click
        allOpenRows: [],
        // id for subject reply
        comment_subject_id: 0,
        // for files upload
        file: [],
        filesAccumulatedTemp: [],
        filesAccumulated: [],
        fileUploaded: false,
        // for reply comment
        replyFroalaEditable: false,

        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        ftie_page_obj: null,
        proposalToReject: null,
        proposalToApprove: null,
        proposalFields: [
          { key: 'status_icon', label: '', thClass: 'text-center', sortable: false },
          {
            key: 'approval_status', label: 'Status',
            thClass: 'text-center',
            thStyle: { width: '18%' },
            sortable: true
          },
          { key: 'subject_detail_info.description', label: 'Proposal Detail', thClass: 'text-center', thStyle: { width: '50%' }, sortable: false },
          {
            key: 'create_date',
            label: 'Created Time',
            thClass: 'text-center',
            thStyle: {
              width: '20%'
            },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.create_date;
            }
          },
          {
            key: 'approval_date',
            label: 'Last Update',
            thClass: 'text-center',
            thStyle: {
              width: '20%'
            },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.update_date;
            }
          },
          { key: 'actions', thClass: 'text-center', sortable: false },
          /*
          { key: 'subject_detail_info.comments.length', label: 'Comment', thClass: 'text-center', thStyle: { width: '20%' }, sortable: false } */
        ],
        fields: [
          { key: 'gtc_comments', label: 'GTC Solutions/Feedbacks', thClass: 'align-middle ', thStyle: { width: '40%' }, sortable: false },
          { key: 'gro_comments', label: 'GRO Comments/Feedbacks', thClass: 'align-middle', thStyle: { width: '40%' }, sortable: false },
          { key: 'upload_files', label: 'Files', thClass: 'align-middle', thStyle: { width: '20%' }, sortable: false }
        ],
        subTicketsTableFileds: [
          { key: 'ftie_id', label: 'Sub Ticket', thClass: 'align-middle ', sortable: false },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: false },
          { key: 'gtc_owner', label: 'Ticket Owner', thClass: 'align-middle', sortable: false },
          { key: 'escalated_date', label: 'Escalated Date', thClass: 'align-middle', sortable: false },
          { key: 'action', label: 'Action', thClass: 'align-middle ', sortable: false },
        ],

        // chat room fields aaron added
        fields_chat: [
          { key: 'expand', thClass: 'text-center', sortable: false },
          {
            key: 'subject_category', label: 'Category',
            thClass: 'text-center',
            tdClass: 'text-center',
            thStyle: { width: '15%' },
            sortable: true
          },
          { key: 'subject', label: 'Subject', thClass: 'text-center', thStyle: { width: '50%' }, sortable: false },
          {
            key: 'creation_time',
            label: 'Created Time',
            thClass: 'text-center',
            thStyle: {
              width: '20%'
            },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.create_date;
            }
          },
          {
            key: 'last_update',
            label: 'Last Update',
            thClass: 'text-center',
            thStyle: {
              width: '20%'
            },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.update_date;
            }
          },
          { key: 'comments.length', label: 'Comment', thClass: 'text-center', thStyle: { width: '20%' }, sortable: false }
        ],

        inMailGroup: false,
        ticket_owner_options: [],
        ticket_l1_owner_options: [],
        champion_comment: "My comment",
        sub_ticket_owner: null,
        subjectCategoryOptions: [
          { value: '', text: '--Select One--' },
          { value: 'Proposal/Solution', text: 'Proposal/Solution' },
          { value: 'Part Number', text: 'Part Number' },
          { value: 'MSFT Autopilot Updates', text: 'MSFT Autopilot Updates' },
          { value: 'Customization Detail', text: 'Customization Detail' },
          { value: 'Completing Ticket', text: 'Completing Ticket' },
          { value: 'NRE Status', text: 'NRE Status' },
          { value: 'Legal Document', text: 'Legal Document' },
          { value: 'Technical Issue', text: 'Technical Issue' },
          { value: 'Ticket Reopen', text: 'Ticket Reopen' },
          { value: 'Service Related', text: 'Service Related' },
          { value: 'Sector Solution', text: 'Sector Solution' },
          { value: 'Others', text: 'Others' }
        ],
        aliveCategoris: [
          { value: '', text: null },
          { value: 'Proposal/Solution', text: 'I want to propose a solution for this ES request.' },
          { value: 'Part Number', text: 'I want to provide the customization P/N.' },
          { value: 'MSFT Autopilot Updates', text: 'Changes have been made on ES page regarding the Autopilot request fields.' },
          { value: 'Customization Detail', text: 'I want to describe more about the customization request.' },
          { value: 'Completing Ticket', text: 'Ticket completed, please close the ticket.' },
          { value: 'NRE Status', text: 'Please find/update the latest NRE status here.' },
          { value: 'Legal Document', text: 'Please find/upload the legal document/NDA here.' },
          { value: 'Technical Issue', text: 'I want to describe more about the technical issue.' },
          { value: 'Ticket Reopen', text: 'Reopen the ticket.' },
          { value: 'Service Related', text: 'This is for service related topics.' },
          { value: 'Sector Solution', text: 'I want to describe more about the Sector Solution Request.' },
          { value: 'Others', text: 'Others' }
        ],
        reason_category_options: [
          { value: '', text: '--Select One--' },
          { value: 'CAB/INF Driver', text: 'CAB/INF Driver' },
          { value: 'Driver', text: 'Driver' },
          { value: 'Firmware', text: 'Firmware' },
          { value: 'HD Image', text: 'HD Image' },
          { value: 'Retrofit Instruction', text: 'Retrofit Instruction' },
          { value: 'SDK', text: 'SDK' },
          { value: 'Technical Inquiry', text: 'Technical Inquiry' },
          { value: 'Technical Support', text: 'Technical Support' },
          { value: 'Utility', text: 'Utility' },
          { value: 'I/O Port Modification', text: 'I/O Port Modification' },
          { value: "Implement Customer's Module", text: "Implement Customer's Module" },
          { value: 'New Certification', text: 'New Certification' },
          { value: 'Development Document', text: 'Development Document' },
          { value: 'Product Improvement', text: 'Product Improvement' },
          { value: 'Others', text: 'Others' },
        ],
        es_category1: { uni_id: null, reason_result: null, reason_type: 'Reason 1' },
        es_category2: { uni_id: null, reason_result: null, reason_type: 'Reason 2' },
        es_category3: { uni_id: null, reason_result: null, reason_type: 'Reason 3' },
        es_solution: { uni_id: null, reason_result: null, reason_type: 'Reason 4' },
        es_key_account: { uni_id: null, reason_result: null, reason_type: 'Reason 5' },
        request_reasons: [],
        froala_comment: null,
        login_user_name: null,
        userSites: null,
        userRoles: null,
        userFunctions: null,
        froalaEditable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        closeSubTicketFTIE: null,
        closeSubTicketReason: '',
        closeMasterTicketFTIE: null,
        closeMasterTicketReason: '',
        temp_gro_owner: '',
        temp_gtc_owner: '',
        temp_gro_site: '',
        ticketOpen: true,
        ticketNeedPn: true,
        sfdcProducts: null,
        basicInfo: null,
        es_main_es_info: null,
        sf_es_info: null,
        sf_opty_info: null,
        etoSectorSkus: null,
        ticketAssessInfo: null,
        kickoff_files: null,
        all_realated_attachments: [],
        chatroomAttachmentSetting: [
          { key: 'FILE_NAME', label: 'File Name', thClass: 'align-middle ', sortable: true },
          { key: 'UPDATE_DATE', label: 'Upload Time', thClass: 'align-middle ', sortable: true },
          { key: 'ACTION', label: 'ACTION', thClass: 'align-middle ', sortable: false },
        ],
        GRO_options: [
          { value: 'GDE', text: 'GDE' },
          { value: 'Getac', text: 'Getac' },
          { value: 'GFR', text: 'GFR' },
          { value: 'GMD-AFME', text: 'GMD-AFME' },
          { value: 'GMD-AU', text: 'GMD-AU' },
          { value: 'GMD-E.ASIA', text: 'GMD-E.ASIA' },
          { value: 'GMD-IN', text: 'GMD-IN' },
          { value: 'GMD-IT', text: 'GMD-IT' },
          { value: 'GMD-LATAM', text: 'GMD-LATAM' },
          { value: 'GMD-CISCEE', text: 'GMD-CISCEE' },
          { value: 'GMD-S.ASIA', text: 'GMD-S.ASIA' },
          { value: 'GMD-W.EU', text: 'GMD-W.EU' },
          { value: 'GML', text: 'GML' },
          { value: 'GTK', text: 'GTK' },
          { value: 'GUK', text: 'GUK' },
          { value: 'GUSA', text: 'GUSA' },
          { value: 'OTHERS', text: 'OTHERS' },
        ],
        sfdc_prd_line_loading: true,
        isCollapsed: false,
        skuPnDisplayed: true,
        activeTab: 0,
        autoPnFields: [
          //{ key: 'INTERFACE_ID', label: '#', thClass: 'text-nowrap ' },
          { key: 'CUSTOMIZATION_TYPE', label: 'TYPE', thClass: 'text-nowrap ' },
          { key: 'NEW_MPS_PN', label: 'New MPS PN', thClass: 'text-nowrap ' },
          { key: 'ITEM_DESC_MPS', label: 'MPS ITEM DESC', thClass: 'text-nowrap ' },
          { key: 'NEW_SHIP_PN', label: 'New SHIP PN', thClass: 'text-nowrap ' },
          { key: 'ITEM_DESC_SHIP', label: 'SHIP ITEM DESC', thClass: 'text-nowrap ' },
          { key: 'SKUID', label: 'Ref Sku', thClass: 'text-nowrap ' },
          { key: 'REFERENCE_MPS_PN', label: 'Ref MPS PN', thClass: 'text-nowrap ' },
          { key: 'REFERENCE_SHIP_PN', label: 'Ref SHIP PN', thClass: 'text-nowrap ' },
          { key: 'COUNTRY_CODE', label: 'Country Code', thClass: 'text-nowrap ' },
          //{ key: 'TAA_FLAG', label: 'TAA', thClass: 'text-nowrap ' },
          //{ key: 'FROM_COMPONENT_MPS', label: 'FROM_COMPONENT_MPS', thClass: 'text-nowrap ' },
          //{ key: 'TO_COMPONENT_MPS', label: 'TO_COMPONENT_MPS', thClass: 'text-nowrap ' },
          //{ key: 'FROM_COMPONENT_SHIP', label: 'FROM_COMPONENT_SHIP', thClass: 'text-nowrap ' },
          //{ key: 'TO_COMPONENT_SHIP', label: 'TO_COMPONENT_SHIP', thClass: 'text-nowrap ' },
          { key: 'MODEL', label: 'Model', thClass: 'text-nowrap ' },
          { key: 'PRODUCT_CODE', label: 'Product Code', thClass: 'text-nowrap ' },
          { key: 'PROCESS_RESULT', label: 'Result', thClass: 'text-nowrap ' },
          //{ key: 'ERROR_MESSAGE', label: 'Msg', thClass: 'text-nowrap ' },
          //{ key: 'PROCESS_START_DATE', label: 'PROCESS_START_DATE', thClass: 'text-nowrap ' },
          //{ key: 'PROCESS_END_DATE', label: 'PROCESS_END_DATE', thClass: 'text-nowrap ' },
        ],
        autopn_items: [],
        tracking_data_loading: true,
        without_unique_pn: true
      }
    },
    computed: {
      sales_director() {
        let self = this;
        let sales_director = _.find(self.ftie_page_obj.mail_loop, { role: 'GRO RSM Manager' });
        return sales_director
      },
      computed_customization_request() {
        let self = this;
        if (self.es_main_es_info==null) {
          return null;
        }
        if (self.es_main_es_info.customization_info.customization_request) {
          return safeHtml(self.es_main_es_info.customization_info.customization_request.replace(/\n/g, "<br>"));
        }

        return null;
      },
      tracking_edit_permission() {
        let self = this;
        if (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.login_user_name === self.ftie_page_obj.gtc_owner
          || (self.login_user_name === 'power')
          || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1)
          || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
          || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
        ) {
          // || (self.userRegions && _.indexOf(self.userRegions, 'Getac') > -1)
          return true
        }
        else {
          return false
        }
      },
    },
    created() {
      let self = this;
      self.userSites = self.prop_user_sites;
      self.login_user_name = self.prop_user;
      self.userRoles = self.prop_user_roles;
      self.userFunctions = this.$session.get('user_functions');
      self.ftie_page_obj = self.prop_ftie_page_obj;
      self.getUnreadSubject();
      self.checkInMailGroup();
      if (_.get(self.ftie_page_obj, 'status', '') === 'Close') {
        self.ticketOpen = false;
      } else {
        self.ticketOpen = true;
      }
      self.getSfProductline();
      self.getEsInfo();
      if ((self.userRoles && _.indexOf(self.userRoles, 'ES_PM') > -1) || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1))
      {
        self.getAutoPnRequests()
      }
      self.getLatestTracking();
    },
    mounted() {
      let self = this;
    },
    watch: {
      paper: function () {
        if (this.paper.length == this.titleText.length) {
          this.paper = ''
        }
      },
      paperOutput: function () {
        if (this.paperOutput.length == this.printerForOutputText.length) {
          this.paperOutput = '';
          this.printerForOutputText = '';
          this.stoperOutput();
        }
      },
      filesAccumulatedTemp: function () {
        let self = this;
        if (self.filesAccumulatedTemp) {
          // 合併 A 和 B 的檔案列表
          let tempFiles = [
            ...self.filesAccumulatedTemp, // B 優先
            ...self.filesAccumulated.filter(file => !this.filesAccumulatedTemp.some(bFile => bFile.name === file.name)) // A 中沒有被 B 覆蓋的檔案
          ];
          self.filesAccumulated = tempFiles;
        }
      },
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
        //return 'DEV' !== this.$session.get('mode');
      },
      ifShowOptyLink(recordSite) {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Admin and ES PM Leader -> SFDC Page Link Enabled!!");
          return true
        }
        else {
          if ((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA_Leader') > -1))
          {
            console.log("GUSA SA");
            // check same site first
            if (self.userSites !== null && self.userSites.includes(recordSite)) {
              // new add check: not international support, like amanda :: user role not contains 'International Solution PM'
              if (_.indexOf(self.userRoles, 'International Solution PM') < 0
                && ( (self.userFunctions && _.indexOf(self.userFunctions, 'International Solution PM') < 0) || (self.userFunctions === null) )
                ) {
                return true;
              }
              else {
                false
              }
            }
            else {
              return false;
            }
          }
        }
        return false;
      },
      approveProposalPermission() {
        let self = this;
        if (self.login_user_name === self.ftie_page_obj.gro_owner
          || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1) || (self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ASSIGNER') > -1)
        ) {
          return true
        }
        else {
          return false
        }
      },
      triggerAutomationPermission(automation_task) {
        if (automation_task === 'Automate NRE') {
          let self = this;
          if (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.login_user_name === self.ftie_page_obj.gtc_owner
            || (self.login_user_name === 'power')
            || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userRoles && _.indexOf(self.userRoles, 'ES_PM') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
          ) {
            // || (self.userRegions && _.indexOf(self.userRegions, 'Getac') > -1)
            return true
          }
          else {
            return false
          }
        }
        if (automation_task === 'Automate PN') {
          let self = this;
          if (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.login_user_name === self.ftie_page_obj.gtc_owner
            || (self.login_user_name === 'power')
            || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
            || (self.userSites && _.indexOf(self.userSites, 'Getac') > -1 && self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
          ) {
            return true
          }
          else {
            return false
          }
        }
        return false;
      },

      editSubjectPermisson() {
        let self = this;
        if (self.login_user_name === self.ftie_page_obj.gtc_owner
          || self.login_user_name === 'power'
          || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1) || (self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ES_PM') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'HQ_ES') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ASSIGNER') > -1)
        ) {
          // || (self.userRegions && _.indexOf(self.userRegions, 'Getac') > -1)
          return true
        }
        else {
          return false
        }
      },

      stoperOutput() { // put stop functions here
        clearInterval(this.timer);
        this.paperOutput = ''
      },

      printer() { // put start function herep
        this.stoper();
        let i = -1;
        this.timer = setInterval(() => {
          i++
          const x = i % this.titleText.length
          this.paper += this.titleText[x]
        }, 200)
      },
      stoper() { // put stop functions here
        clearInterval(this.timer);
        this.paper = ''
      },
      managerAccessFtie() {
        let self = this;
        return self.$options.filters['adminAccessFtie'](self.login_user_name, null, null);
      },

      // aaron
      log(message) {
        console.log(message)
      },
      modalId(i) {
        return 'modal' + i;
      },
      commentId(i) {
        return 'comment' + i;
      },
      upload(key) {
        let a = `uploader_${key}`;
        this.$refs[a][0].click();
      },
      setSubjectDefaultContext() {
        let self = this;
        if (_.get(self.temp_subject, 'subject_category', null) !== null) {
          let chosenObj = _.find(self.aliveCategoris, { 'value': self.temp_subject.subject_category });
          if (chosenObj !== null) {
            let defaultText = chosenObj['text'];
            _.set(self.temp_subject, 'subject', defaultText)
          }
        }
      },

      // open only one subject at a time by checking subject_id
      handleRowClicked(item, index) {
        let self = this;
        self.$set(item, "_showDetails", !item._showDetails);
        if (item._showDetails) {
          let read_comments = _.filter(item.comments, comment => {
            return (comment.unread_gro_member === self.login_user_name || comment.unread_gtc_member === self.login_user_name)
              && !comment.reply_comment_id
          });
          if (read_comments.length > 0 || (item.unread_gro_member === self.login_user_name || item.unread_gtc_member === self.login_user_name)) {
            self.readComment(read_comments, item);
          }
        }
        // set froala editable to true
        self.newCommentFroala()
        // set files to null & not uploaded
        self.filesAccumulated = []
        self.fileUploaded = false
      },
      // trigger when add button in add subject b-modal is clicked
      handleSubjectOk() {
        let self = this;
        //for (let i = 0; i < self.filesAccumulated.length; i++) {
        //  this.temp_attachment.file_id = i
        //  this.temp_attachment.file_name = this.filesAccumulated[i].name
        //  let temp = JSON.parse(JSON.stringify(this.temp_attachment))
        //  this.temp_subject.attachments.push(temp)
        //  this.temp_attachment = JSON.parse(JSON.stringify(this.default_temp_attachment))
        //}
        self.temp_subject.subject_id = null;
        self.temp_subject.create_date = this.formatDate(new Date())
        self.temp_subject.update_date = this.formatDate(new Date())
        self.temp_subject.createby = this.login_user_name
        self.temp_subject.updateby = this.login_user_name
        let url = self.$root.baseUrl + '/ftie/save-chatroom-subject/';

        let formData = new FormData();
        let totalSize = 0;
        let maxLength = Number(self.$root.maxRequestLength);
        for (var i = 0; i < self.filesAccumulated.length; i++) {
          let file = self.filesAccumulated[i];
          totalSize += self.filesAccumulated[i].size;
          formData.append('files', file);
        }
        if (totalSize > maxLength) {
          self.$message.exception('The total size of the files exceeds the allowed limit (15 MB).!');
          return;
        }
        formData.append('request_detail_id', self.ftie_page_obj.request_detail_id);
        formData.append('subject', self.temp_subject.subject);
        formData.append('subject_description', self.temp_subject.description);
        formData.append('subject_category', self.temp_subject.subject_category)
        formData.append('user_name', self.temp_subject.createby);
        formData.append('ftie_id', self.ftie_page_obj.ftie_id);
        formData.append('gtc_owner', self.ftie_page_obj.gtc_owner);
        formData.append('gro_owner', self.ftie_page_obj.gro_owner);

        //#endregion

        //#region -- Data Upload --
        self.$nextTick(() => {
          self.$bvModal.hide('add-subject');
        })
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios
          .post(
            self.$root.baseUrl + '/ftie/save-chatroom-subject/',
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then(response => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }

          })
          //.error((error) => {
          //  console.log(error);
          //  self.$message.exception('Internal Server Error!');
          //})
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.temp_attachment = JSON.parse(JSON.stringify(this.default_temp_subject));
              self.filesAccumulated = [];
              // set fileUploaded to false
              self.fileUploaded = false;
              self.refreshChatroom();
            } else {
              self.$message.exception('Save Error!');
            }
          });

      },
      handleAttachmentOk(subjectKey, commentKey) {
        let self = this;
        //#region -- formData --
        //let files_to_upload = [];
        //self.filesAccumulated.forEach((file) => {
        //  console.log(file);
        //  let a = Object.getPrototypeOf("File");
        //  files_to_upload.append();
        //})
        let formData = new FormData();
        let totalSize = 0;
        let maxLength = Number(self.$root.maxRequestLength);
        // 檢測文件總大小是否超過限制

        for (var i = 0; i < self.filesAccumulated.length; i++) {
          let file = self.filesAccumulated[i];
          totalSize += self.filesAccumulated[i].size;
          formData.append('files', file);
        }
        if (totalSize > maxLength) {
          self.$message.exception('The total size of the files exceeds the allowed limit (15 MB).!');
          return;
        }
        formData.append('subject_id', subjectKey);
        formData.append('user_name', self.login_user_name);
        formData.append('comment_id', commentKey);
        //#endregion

        //#region -- Data Upload --
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios
          .post(
            self.$root.baseUrl + '/ftie/upload-chatroom-attachment/',
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
              params: {
                'token': encodeURI(self.$store.state.token),
                'username': encodeURI(self.$store.state.username)
              }
            }
          )
          .then(response => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }

          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.temp_attachment = JSON.parse(JSON.stringify(this.default_temp_attachment));
              self.filesAccumulated = [];
              // set fileUploaded to false
              self.fileUploaded = false;
              self.refreshChatroom();
            } else {
              self.$message.exception('Save Error!');
            }
          });
        //let fileLength = this.subjects[subjectKey - 1].comments[commentKey - 1].attachments.length
        //for (let i = 0; i < this.filesAccumulated.length; i++) {
        //  this.temp_attachment.file_id = fileLength + i
        //  this.temp_attachment.file_name = this.filesAccumulated[i].name
        //  let temp = JSON.parse(JSON.stringify(this.temp_attachment))
        //  this.subjects[subjectKey - 1].comments[commentKey - 1].attachments.push(temp)
        //  this.temp_attachment = JSON.parse(JSON.stringify(this.default_temp_attachment))
        //}
        // set filesAccumulated to null

      },
      resetModal() {
        this.filesAccumulated = []
        this.filesAccumulatedTemp = []
        this.temp_subject.subject = null
        this.temp_subject.description = null
      },
      filterRealatedAttachments() {
        let self = this;
        let realted_subject_comments = _.filter(self.subjects, item => {
          return item.attachments.length > 0 || (item.comments.length > 0 &&
            _.filter(item.comments, comment => { return comment.attachments.length > 0 }).length > 0)
        })
      },
      // format current date time to YYYY-MM-DD hh:mm:ss
      formatDate(date) {
        return (
          [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
          ].join('-') +
          ' ' +
          [
            this.padTo2Digits(date.getHours()),
            this.padTo2Digits(date.getMinutes()),
            this.padTo2Digits(date.getSeconds()),
          ].join(':')
        );
      },
      padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      },
      saveSubjectComment(subject_id, subject_object) {
        let self = this;
        self.temp_comment.comment_id = null
        self.temp_comment.subject_id = subject_id
        self.temp_comment.createby = this.login_user_name
        self.temp_comment.create_date = this.formatDate(new Date())
        let temp = JSON.parse(JSON.stringify(this.temp_comment))

        // set filesAccumulated to null
        self.filesAccumulated = []
        // set fileUploaded to false
        self.fileUploaded = false
        let url = self.$root.baseUrl + '/ftie/save-chatroom-comment/';

        let request_data = {
          subject_id: subject_id,
          content: self.temp_comment.content,
          reply_comment_id: null,
          ftie_obj: self.ftie_page_obj,
          subject_object: subject_object,
          user_name: self.temp_comment.createby,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            // set temp_comment to default null
            self.temp_comment = JSON.parse(JSON.stringify(this.default_temp_comment))
            eventHub.$emit('loading', false);
            if (save_success) {
              self.refreshChatroom(self.ftie_page_obj.ftie_id);
            }
          })
      },
      proposalApprovalModal(item, operation) {
        let self = this;
        self.proposalToReject = null;
        self.proposalToApprove = null;
        if (item !== null) {
          if (operation === 'reject') {
            self.proposalToReject = JSON.parse(JSON.stringify(item));
            self.$bvModal.show('modal-reject-proposal-' + item.subject_id);
          } else {
            if (operation === 'approve') {
              self.proposalToApprove = null;
              self.proposalToApprove = JSON.parse(JSON.stringify(item));
              self.$bvModal.show('modal-approve-proposal-' + item.subject_id);
            }
          }
        }
      },

      proposalOperations(item, status) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/proposal/do-approval/'; //  + status + '/';
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          subject_id: item.subject_id,
          status: status,
          // user_name: self.temp_comment.createby,
          approve_by: item.approval_by,
          approve_comment: item.approval_comments,
          proposal_info: JSON.parse(JSON.stringify(item)),
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            // set temp_comment to default null
            // self.temp_comment = JSON.parse(JSON.stringify(this.default_temp_comment))
            eventHub.$emit('loading', false);
            if (save_success) {
              self.fetchAllProposals();
            }
          })
      },
      showEditCateogyModel(item) {
        let self = this;
        _.set(self.temp_subject_to_edit, 'subject_category', null);
        _.set(self.temp_subject_to_edit, 'subject_id', null);
        _.set(self.temp_subject_to_edit, 'subject', null);
        _.set(self.temp_subject_to_edit, 'description', null);
        if (item !== null) {
          _.set(self.temp_subject_to_edit, 'subject_category', item.subject_category);
          _.set(self.temp_subject_to_edit, 'subject_id', item.subject_id);
          _.set(self.temp_subject_to_edit, 'subject', item.subject);
          _.set(self.temp_subject_to_edit, 'description', item.description);
          self.$bvModal.show('modal-category-' + item.subject_id);
        }
      },
      editSubject(subject_id, item) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/subject/edit/';
        let request_data = {
          subject_id: subject_id,
          subject_info_obj: JSON.parse(JSON.stringify(item)),
          user_name: self.login_user_name,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.refreshChatroom(self.ftie_page_obj.ftie_id);
            }
          })
      },
      fetchAllProposals() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/proposal/fetch-all/'; //  + status + '/';
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              self.ftie_page_obj = JSON.parse(res['ftie_page_obj']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      // for files upload
      handleSubjectFileUpload() {
        console.log(this.$refs)
        for (let i = 0; i < this.$refs.subjectFile.files.length; i++) {
          this.filesAccumulated.push(this.$refs.subjectFile.files[i])
        }
      },
      handleCommentFileUpload() {
        for (let i = 0; i < this.$refs.commentFile.files.length; i++) {
          this.filesAccumulated.push(this.$refs.commentFile.files[i])
        }
        this.fileUploaded = true
      },
      handleCommentFilesUpload(item) {
        let a = `uploader_${item.comment_id}`;
        //console.log(this.$refs)
        for (let i = 0; i < this.$refs[a][0].files.length; i++) {
          this.filesAccumulated.push(this.$refs[a][0].files[i])
        }
        this.fileUploaded = true
      },
      checkUnreadReply(current_comments, comment_id) {
        let self = this;
        let unread_replys = _.orderBy(_.filter(current_comments, item => {
          return item.reply_comment_id === comment_id && (item.createby !== self.login_user_name &&
            (item.unread_gro_member === self.login_user_name || item.unread_gtc_member === self.login_user_name))
        }), ['update_date'], ['asc']);
        if (unread_replys.length > 0) {
          return true
        }
        return false;
      },
      filterReply(current_comments, comment_id) {
        let self = this;
        let replys = _.orderBy(_.filter(current_comments, item => { return item.reply_comment_id === comment_id; }), ['update_date'], ['asc']);
        let parent_comment = _.find(current_comments, { comment_id: comment_id });
        //replys.map((reply) => {
        //  if (reply.createby !== self.login_user_name &&
        //    (reply.unread_gro_member === self.login_user_name || reply.unread_gtc_member === self.login_user_name)) {
        //    self.$set(parent_comment, "replyRead", false);
        //  } else {
        //    self.$set(parent_comment, "replyRead", true);
        //  }
        //});
        return replys;
      },
      filterParentComments(current_comments) {
        let self = this;
        let parent_comments = _.orderBy(_.filter(current_comments, item => { return item.reply_comment_id == null || item.reply_comment_id == undefined }), ['update_date'], ['asc']);
        //let parent_comments = _.filter(current_comments, item => { return item.reply_comment_id == null || item.reply_comment_id == undefined });
        parent_comments.forEach((comment) => {
          if (comment.reply_visible == undefined) {
            self.$set(comment, "reply_visible", false);
          }
        })
        return parent_comments;
      },
      togglefilterReply(subject, comment) {
        let self = this;
        comment.reply_visible = !comment.reply_visible;
        if (comment.reply_visible) {
          let read_replys = _.filter(subject.comments, reply => {
            return (reply.unread_gro_member === self.login_user_name || reply.unread_gtc_member === self.login_user_name)
              && reply.reply_comment_id == comment.comment_id && reply.createby !== self.login_user_name
          })
          if (read_replys.length > 0) {
            self.readComment(read_replys, subject);
          }
        }
      },
      toggleReplyFroala(key) {
        var self = this;
        var temp_comment_id = this.temp_reply.comment_id
        if (key !== this.temp_reply.comment_id) {
          this.replyFroalaEditable = true;
          this.temp_reply.comment_id = key;
        } else {
          this.temp_reply.comment_id = key;
          this.replyFroalaEditable = !this.replyFroalaEditable;
        }
      },
      saveCommentReply(comment, subject_object) {
        let self = this;
        self.temp_reply.comment_id = null;
        self.temp_reply.subject_id = comment.subject_id
        self.temp_reply.reply_id = comment.comment_id
        self.temp_reply.createby = self.login_user_name
        self.temp_reply.create_date = self.formatDate(new Date())
        let temp = JSON.parse(JSON.stringify(self.temp_reply))
        /*        bvModalEvt.preventDefault();*/
        let url = self.$root.baseUrl + '/ftie/save-chatroom-comment/';

        let request_data = {
          subject_id: comment.subject_id,
          content: self.temp_reply.content,
          reply_comment_id: self.temp_reply.reply_id,
          ftie_obj: self.ftie_page_obj,
          subject_object: subject_object,
          user_name: self.temp_reply.createby,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            // set temp_comment to default null
            self.temp_reply = JSON.parse(JSON.stringify(self.default_temp_comment))
            eventHub.$emit('loading', false);
            if (save_success) {
              self.refreshChatroom();
            } else {
              self.$message.exception('Save Error!');
            }
          })
      },
      refreshChatroom() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/chatroom-subject-detail/';

        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              self.ftie_page_obj.subjects = JSON.parse(res['subject_obj']);
              self.all_realated_attachments = res['all_attachments'];
              if (res['proposal_obj'] !== null && res['proposal_obj'].length > 0) {
                self.ftie_page_obj.proposal_solutions = JSON.parse(res['proposal_obj']);
              } else {
                self.ftie_page_obj.proposal_solutions = null;
              }
              self.ftie_page_obj.subjects.map((subject) => {
                if (self.login_user_name == self.ftie_page_obj.gtc_owner || self.login_user_name == self.ftie_page_obj.gro_owner) {
                  if (subject.comments && _.filter(subject.comments, item => {
                    return item.createby !== self.login_user_name &&
                      (item.unread_gro_member === self.login_user_name || item.unread_gtc_member === self.login_user_name)
                  })) {
                    subject.comments.map((comment) => {
                      self.$set(comment, "read", true);
                    });
                  }
                } else {
                  subject.comments.map((comment) => {
                    self.$set(comment, "read", false);
                  });
                }

              });
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      //initJqueryFUnction() {
      //  $('#solution_comment_table img').css("width", "300");
      //  $('#solution_comment_table table').css("width", "300");
      //},
      filterReasonCategory() {
        let self = this;
        if (self.request_reasons.length != 0) {
          self.es_category1 = _.find(self.request_reasons, { reason_type: 'Reason 1' });
          self.es_category2 = _.find(self.request_reasons, { reason_type: 'Reason 2' });
          self.es_category3 = _.find(self.request_reasons, { reason_type: 'Reason 3' });
          self.es_solution = _.find(self.request_reasons, { reason_type: 'Reason 4' });
          self.es_key_account = _.find(self.request_reasons, { reason_type: 'Reason 5' });
        }
      },
      checkInMailGroup() {
        let self = this;
        let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === self.login_user_name; })
        let gmlSaMember = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === 'gmlsa.gml'; })
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang']
        if (members.length > 0 || (gmlSaMember.length > 0 && defaultGmlSaMembers.includes(self.login_user_name))) {
          self.inMailGroup = true;
        }
        if (self.inMailGroup) {
          self.fields.push({ key: 'action', label: 'Action', thClass: 'align-middle', thStyle: { 'min-width': '10% !important' }, sortable: false });
        } else {
          _.remove(self.fields, { label: 'Action' });
        }

      },
      redirectRequestForm() {
        window.location.href = `${self.frontendUrl.slice(0, -1)}/ftie/request-form/${self.ftie_page_obj.ftie_id}`;
      },
      showReAssignTicketModal() {
        let self = this;
        console.log("ftie site");
        console.log(self.ftie_page_obj.site);
        console.log("es id/sfdc");
        console.log(_.get(self.ftie_page_obj, 'salesforce_es_id', ''));

        self.temp_gro_site = self.ftie_page_obj.site;
        self.temp_gro_owner = _.get(self.ftie_page_obj, 'gro_owner', '');
        self.temp_gtc_owner = _.get(self.ftie_page_obj, 'gtc_owner', '');
        // self.getOwnerList();
        self.getOwnerListByPost();
        self.$refs['ReAssignTicketModal'].show();
      },
      showAssignSubTicketModal() {
        let self = this;
        // self.getOwnerList();
        self.getOwnerListByPost();
        self.$refs['AssignSubTicketModal'].show();
      },
      getOwnerListByPost() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners/';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list_all = [];
        let gro_owner_list = [];
        let gro_owner_list_by_original_sa = [];
        /**  Region: Call POST Method to get ticket owner list*/
        let request_data = {
          original_create_by: _.get(self.ftie_page_obj, 'gro_owner', ''),
        };
        self.$axios.post(url, request_data)
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              gtc_owner_list = JSON.parse(res['gtc_owner_list']);
              gro_owner_list_all = JSON.parse(res['gro_owner_list']);
              gro_owner_list_by_original_sa = JSON.parse(res['gro_owner_list_by_original_sa']);

              console.log("[getOwnerListByPost] gro_owner_list ALL REGION:");
              console.log(gro_owner_list_all);
              console.log("[getOwnerListByPost] gro_owner_list_by_original_sa:");
              console.log(gro_owner_list_by_original_sa);

              if (gro_owner_list_all.length > 0) {
                let groOptions = _.filter(gro_owner_list_all, item => item.site == _.get(self.ftie_page_obj, 'site', '') || _.get(self.ftie_page_obj, 'site', '') == '');
                gro_owner_list = _.uniq(_.map(groOptions, function (item) {
                  return item.member_gulid;
                }));
              }
              console.log("[getOwnerListByPost] gro_owner_list (filter by Site):");
              console.log(gro_owner_list);

            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.ticket_owner_options = gtc_owner_list;
            if (gro_owner_list_by_original_sa != null && gro_owner_list_by_original_sa.length > 0) {
              self.ticket_l1_owner_options = gro_owner_list_by_original_sa;
            } else {
              self.ticket_l1_owner_options = gro_owner_list;
            }
            console.log("l1_owner_options");
            console.log(self.ticket_l1_owner_options);
            console.log("request_detail_id");
            console.log(self.ftie_page_obj.request_detail_id);

          });

        /**  End Region: POST Method to get ticket owner list*/

      },

      /* -- tmp:remove belwo GET method, using POST as above instead */
  /*
      getOwnerList() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list = [];

        self.$axios.get(url, { params })
        .then((response) => {
          var res = response.data;
          if (response.status === 200) {
            gtc_owner_list = JSON.parse(res['gtc_owner_list']);
            gro_owner_list = JSON.parse(res['gro_owner_list']);
          }
          else if (res.description == "login") {
            self.$session.destroy();
            self.$store.commit('clearToken');
            var url = self.$root.baseUrl + '/auth/logout/';
            self.$axios.get(url)
              .then((res) => {
                self.$router.push("/");
              })
            window.location = self.frontEndUrlToUse + 'azure-login';
          } else {
            self.$message.exception('Internal Server Error!');
            console.log(res.description);
          }
        }, (error) => {
          console.log(error);
          self.$message.exception('Internal Server Error!');
        })
        .finally(() => {
          eventHub.$emit('loading', false);
          self.ticket_owner_options = gtc_owner_list;
        });
      },
      */

      saveChampionComment(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/champion-comment-save/';

        let request_data = {
          uni_id: self.ftie_page_obj.champion_comment_id,
          ftie_id: self.ftie_page_obj.ftie_id,
          champion_comments: self.ftie_page_obj.champion_comments
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            }
          })
        self.$nextTick(() => {
          self.$refs['ChampionModal'].hide();
        })
      },
      saveKeyword(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/keyword-save/';

        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          keyword: self.ftie_page_obj.keyword
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            }
          })
        self.$nextTick(() => {
          self.$refs['KeywordModal'].hide();
        })
      },
      assignSubTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/sub-ticket-save/';

        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          master_ticket_site: self.ftie_page_obj.site,
          sub_ticket_owner: self.sub_ticket_owner
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            }
          })
        self.$nextTick(() => {
          self.$refs['AssignSubTicketModal'].hide();
        })
      },
      assignTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/reassign-ticket/';

        let assigned_site = '';
        if (self.temp_gro_site === '' || self.temp_gro_site === null) {
          assigned_site = self.ftie_page_obj.site;
        } else {
          assigned_site = self.temp_gro_site
        }

        let request_data = {
          request_detail_id: self.ftie_page_obj.request_detail_id,
          assigned_ticket_owner: self.temp_gtc_owner,
          assigned_ticket_l1_owner: self.temp_gro_owner,
          login_user_name: self.login_user_name,
          ftie_id: self.ftie_page_obj.ftie_id,
          assigned_site: assigned_site,
          original_site: self.ftie_page_obj.site,
          es_id_in_opty_obj: _.get(self.ftie_page_obj, 'salesforce_es_id', ''),
          es_owner_id: _.get(self.ftie_page_obj, 'es_owner_id', ''),
          l1_original_owner_name: _.get(self.ftie_page_obj, 'gro_owner', ''),
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              window.location = self.frontEndUrlToUse + 'ftie/ftie-page/' + self.ftie_page_obj.ftie_id;
            }
          })
        self.$nextTick(() => {
          self.$refs['ReAssignTicketModal'].hide();
        })
      },
      saveRequestReason(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/request-reason/';

        let request_reasons = new Array();
        request_reasons.push(self.es_category1);
        request_reasons.push(self.es_category2);
        request_reasons.push(self.es_category3);
        request_reasons.push(self.es_key_account);
        request_reasons.push(self.es_solution);

        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          request_reasons: request_reasons
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            }
          })
        self.$nextTick(() => {
          self.$refs['ReasonModal'].hide();
        })
      },
      showChampionModal() {
        this.$refs['ChampionModal'].show()
      },
      showKeywordModal() {
        this.$refs['KeywordModal'].show()
      },
      showReasonModal() {
        var self = this;
        self.$refs['ReasonModal'].show()
        let ftie_id = encodeURIComponent(self.ftie_page_obj.ftie_id);
        let url = self.$root.baseUrl + `/ftie/request-reason?ftie_id=${ftie_id}`;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let request_reasons = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              request_reasons = JSON.parse(res['request_reasons']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.request_reasons = request_reasons;
            self.filterReasonCategory();
          });
      },
      saveSolutionComment(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/save-solution-comment/';
        let user_name = '';
        let gmlSaMember = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === 'gmlsa.gml'; })
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang']
        if (gmlSaMember.length > 0 && defaultGmlSaMembers.includes(self.login_user_name)) {
          user_name = 'gmlsa.gml';
        } else {
          user_name = self.login_user_name;
        }
        let user_role = [];
        let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === user_name; })
        if (members.length > 0) {
          user_role = members[0].role;
        }
        let request_data = {
          request_detail_id: self.ftie_page_obj.request_detail_id,
          user_role: user_role,
          solution_comment: self.froala_comment,
          login_user_name: self.login_user_name,
          ftie_obj: self.ftie_page_obj
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.froala_comment = null;
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            }
          })
      },
      newCommentFroala() {
        let self = this;
        self.froala_comment = { 'result_id': null, 'comments': '', 'customer_comments': '', 'new_comments': null };
        self.froalaEditable = true;
      },
      editSolutionComment(solution_comment, index) {
        let self = this;
        self.froala_comment = { 'result_id': solution_comment.result_id, 'comments': solution_comment.gtc_comments, 'customer_comments': solution_comment.gro_comments, 'new_comments': null };
        self.$refs.selectableTable.selectRow(index);
        self.froalaEditable = true;
      },

      uploadfile(event, result_id) {
        let self = this;
        let maxLength = Number(self.$root.maxRequestLength);
        if (event) event.preventDefault();
        if (event.target.files.length === 0) return;
        if (_.first(event.target.files).size > maxLength) {
          self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
          return;
        }



        //#endregion
        let user_name = '';
        let gmlSaMember = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === 'gmlsa.gml'; })
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang']
        if (gmlSaMember.length > 0 && defaultGmlSaMembers.includes(self.login_user_name)) {
          user_name = 'gmlsa.gml';
        } else {
          user_name = self.login_user_name;
        }
        let user_role = [];
        let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === user_name; })
        if (members.length > 0) {
          user_role = members[0].role;
        }

        //#region -- formData --
        let formData = new FormData();
        formData.append('file', _.first(event.target.files));
        formData.append('ftie_id', self.ftie_page_obj.ftie_id);
        formData.append('user_name', self.login_user_name);
        formData.append('result_id', result_id);
        formData.append('user_role', user_role);
        formData.append('file_category', 'solution_comment');
        //#endregion
        //#region -- Data Upload --
        eventHub.$emit('loading', true);
        self.$axios
          .post(
            self.$root.baseUrl + '/ftie/upload-file/',
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then(res => {
            self.getFtiePage(self.ftie_page_obj.ftie_id);
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },

      getFtiePage(ftie_id) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/page-with-chatroom/';
        let request_data = {
          ftie_id: ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let ftie_page_obj = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              ftie_page_obj = JSON.parse(res['ftie_page_obj']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.ftie_page_obj = ftie_page_obj;
            if (_.get(self.ftie_page_obj, 'status', '') === 'Close') {
              self.ticketOpen = false;
            } else {
              self.ticketOpen = true;
            }
            eventHub.$emit('loading', false);
          })
      },
      showSaCloseTicket(ftie_id) {
        let self = this;
        if (_.get(self.ftie_page_obj, 'status', '') === 'Close') {
          self.ticketOpen = false;
        } else {
          self.ticketOpen = true;
        }
        self.closeMasterTicketFTIE = ftie_id;
        self.closeMasterTicketReason = '';
        self.$refs['SaCloseMasterTicketModal'].show()
      },
      validateCloseReason() {
        let self = this;
        if (self.closeMasterTicketReason === null || _.trim(self.closeMasterTicketReason) === '') {
          self.$message.warning(`Please enter the close reason.`);
          return false;
        } else {
          if (self.closeMasterTicketReason.length > 255) {
            let text = `The max length of 255 characters in Close Reason is reached. You typed in ${self.closeMasterTicketReason.length} characters`;
            self.$message.warning(text, 'Max Length Reached: Close Reason');
            return false;
          }
        }
        return true;
        //_.each(self.nreData.page_object.quote_items, item => { item.quote_to_gro = 'N'; });
      },

      closeMasterTicket(bvModalEvt) {
        let self = this;
        if (self.validateCloseReason() === true) {
          bvModalEvt.preventDefault();
          let url = self.$root.baseUrl + '/ftie/close-master-ticket/';

          // let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === self.login_user_name; })
          let request_data = {
            ftie_id: self.closeMasterTicketFTIE,
            close_reason: self.closeMasterTicketReason
          };
          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };
          eventHub.$emit('loading', true);
          let save_success = false;
          self.$axios.post(url, request_data, { params })
            .then((response) => {
              var res = response.data;
              //console.log(res);

              if (response.status === 200) {
                save_success = JSON.parse(res['save_success']);
              }
              else if (res.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location = self.frontEndUrlToUse + 'azure-login';
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
                //console.log(res['msg'])
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            })
            .finally(() => {
              eventHub.$emit('loading', false);
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            })
          self.$nextTick(() => {
            if (_.get(self.ftie_page_obj, 'status', '') === 'Close') {
              self.ticketOpen = false;
            } else {
              self.ticketOpen = true;
            }
            self.$refs['SaCloseMasterTicketModal'].hide();
          })
        }
      },


      showCloseSubTicketModal(ftie_id) {
        let self = this;
        self.closeSubTicketFTIE = ftie_id;
        self.closeSubTicketReason = '';
        self.$refs['CloseSubTicketModal'].show()
      },
      closeSubTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/close-sub-ticket/';

        let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === self.login_user_name; })
        let request_data = {
          ftie_id: self.closeSubTicketFTIE,
          close_reason: self.closeSubTicketReason
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFtiePage(self.ftie_page_obj.ftie_id);
            }
          })
        self.$nextTick(() => {
          self.$refs['CloseSubTicketModal'].hide();
        })
      },
      getSfEsAttachment(escalation_file) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/sf-es-attachment/';
        if (escalation_file.file_path.includes('https')) {
          let request_data = {
            file_name: escalation_file.file_name,
            file_url: escalation_file.file_path,
          };
          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };
          eventHub.$emit('loading', true);
          self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
            .then((response) => {

              if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                //console.log("file_name =" + escalation_file.file_name);
                link.setAttribute('download', escalation_file.file_name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }
              else if (res.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location = self.frontEndUrlToUse + 'azure-login';
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            })
            .finally(() => {
              eventHub.$emit('loading', false);
            })

        }
      },
      downloadSfEsAttachment(attachment_id, file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/engineering-service/attachment/download/';
        let request_data = {
          user_name: self.login_user_name,
          attachment_id: attachment_id,
          file_name: file_name
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((response) => {

            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              //console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })

      },
      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      subjectLengthValidate(bvModalEvt) {
        let self = this;
        let validateColumns = ['subject', 'description']; // MAX = 2000
        bvModalEvt.preventDefault();
        /* MAX = 60 */
        for (var i = 0; i < validateColumns.length; i++) {
          if (_.get(self.temp_subject, validateColumns[i], '') !== '' && _.get(self.temp_subject, validateColumns[i], '') !== null) {
            if (_.get(self.temp_subject, validateColumns[i], '').length > 1000) {
              let text = `The max length of 1000 characters in ${validateColumns[i]} is reached. You typed in ${_.get(self.temp_subject, validateColumns[i], '').length} characters`;
              self.$message.warning(text, 'Max Length Reached');
              return false;
            }
          } else {
            let text = `Please type in ${validateColumns[i]}`;
            self.$message.warning(text, 'Column information is required');
            return false;
          }
        }
        return true;
      },
      expandAllSubject(IsExpanded) {
        if (this.ftie_page_obj.subjects) {
          this.ftie_page_obj.subjects.map((subject) => {
            this.$set(subject, "_showDetails", IsExpanded);
            if (subject.comments) {
              subject.comments.map((comment) => {
                this.$set(comment, "reply_visible", IsExpanded);
              });
            }
          });
        }
        // set froala editable to true
        this.newCommentFroala()
        // set files to null & not uploaded
        this.filesAccumulated = []
        this.fileUploaded = false
      },
      deleteTempFile(bvModalEvt, index) {
        bvModalEvt.preventDefault();
        this.filesAccumulatedTemp = [];
        this.$delete(this.filesAccumulated, index);
      },
      downloadAttachment(file_name, origin_file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/upload_file/' + file_name;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          origin_file_name: origin_file_name
        };
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params, responseType: 'arraybuffer' })
          .then((response) => {
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              //console.log("file_name =" + origin_file_name);
              link.setAttribute('download', origin_file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (response.status === 401) {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      checkETOSectorVisibility() {
        let self = this;
        if (self.ftie_page_obj === null || self.ftie_page_obj.type !== 'ETO Sector SKU') {
          return false
        }
        else {
          if (self.userRoles !== null && (self.userRoles.includes('ASSIGNER') || self.userRoles.includes('Admin') || _.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1)
            || self.login_user_name === self.ftie_page_obj.gtc_owner
            || self.login_user_name === 'power'
            || self.login_user_name === self.ftie_page_obj.gro_owner) {
            return true;
          }
          if (self.editSubjectPermisson()) { return true }
          else {
            return false;
          }
        }
      },
      checkAssignerPermission() {
        let self = this;
        if (self.userRoles !== null && (self.userRoles.includes('ASSIGNER') || self.userRoles.includes('Admin'))) {
          return true;
        }
        return false
      },
      checkSiteChangePermission() {
        let self = this;
        if (self.ftie_page_obj === null
          || _.get(self.ftie_page_obj, 'salesforce_es_id', '') === null
          || _.get(self.ftie_page_obj, 'salesforce_es_id', '') === '') {
          return false;
        }
        if (self.userRoles !== null && self.userRoles.includes('Admin')) {
          return true;
        }
        if (self.userSites !== null && self.userSites.includes('Getac') && self.userRoles !== null && self.userRoles.includes('ES_PM_Leader')) {
          return true;
        }

        return false
      },
      checkTransferL1Permission() {
        // SA Head from the region can transfer L1(GRO Owner)
        let self = this;
        if (self.ftie_page_obj === null
          || _.get(self.ftie_page_obj, 'salesforce_es_id', '') === null
          || _.get(self.ftie_page_obj, 'salesforce_es_id', '') === '') {
            return false
        }
        if (self.userRoles !== null && (self.userRoles.includes('ASSIGNER') || self.userRoles.includes('Admin'))) {
          return true;
        }
        if (self.userSites !== null && self.userSites.includes(self.ftie_page_obj.site)
          &&
          (self.login_user_name === self.ftie_page_obj.gro_owner
          || self.userRoles !== null && _.indexOf(self.userRoles, 'GRO_SA_MANAGER') > -1)
        ) {
          return true;
        }
        return false
      },
      commentRowClass(item, type) {
        if (item && type === 'row') {
          if (item.read === false) {
            return 'table-row-highlight table-row-bold'
          } else {
            return null
          }
        } else {
          return null
        }
      },
      readComment(comment_list, subject) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/read-comment/';
        let subject_id = null;
        if (subject.unread_gro_member == self.login_user_name) {
          subject_id = subject.subject_id;
          self.$set(subject, "unread_gro_member", null);
        }
        if (subject.unread_gtc_member == self.login_user_name) {
          subject_id = subject.subject_id;
          self.$set(subject, "unread_gtc_member", null);
        }
        let comment_id_list = []
        comment_list.forEach((comment) => {
          comment_id_list.push(comment.comment_id)
          if (comment.unread_gro_member == self.login_user_name) {
            self.$set(comment, "unread_gro_member", null);
          }
          if (comment.unread_gtc_member == self.login_user_name) {
            self.$set(comment, "unread_gtc_member", null);
          }
        })
        let request_data = {
          comment_id_list: comment_id_list,
          subject_id: subject_id,
          ftie_id: self.ftie_page_obj.ftie_id,
          login_user_name: self.login_user_name
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            if (!save_success) {
              self.$message.exception('Read Comment Error!');
            }
            else {
              self.getUnreadSubject();
            }
            eventHub.$emit('loading', false);
          })
      },
      getTicketAssessInfo() {
        let self = this;
        let requestData = {
          create_by: self.ftie_page_obj.gtc_owner,
          username: self.login_user_name,
          ftie_id: self.ftie_page_obj.ftie_id,
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/assess-info/', requestData)
          .then(res => {
            let result = res.data;
            console.log('../assess-info/ result');
            //console.log(result);
            //result.eto_sector_sku_list = JSON.parse(result.eto_sector_sku_list);

            if (_.get(result, 'assess_info', null) !== null &&
              _.size(_.get(result, 'assess_info', new Array())) > 0) {
              result.assess_info = JSON.parse(result.assess_info);
            }

            //console.log("result.assess_info::");
            //console.log(result.assess_info);
            self.ticketAssessInfo = result.assess_info

          })
          .finally(() => {
            console.log("COMPLETE ../assess-info/");
            eventHub.$emit('loading', false);
          });
      },
      getEtoSectorSkuInfo() {
        let self = this;
        let requestData = {
          create_by: self.ftie_page_obj.gtc_owner,
          username: self.login_user_name,
          ftie_id: self.ftie_page_obj.ftie_id,
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        // eto-sector-sku/info; ftie/get-eto-sector-sku-info
        this.$axios
          .post(self.$root.baseUrl + '/eto-sector-sku/info/', requestData)
          .then(res => {
            let result = res.data;
            console.log('eto-sector-sku/info/ result');
            //console.log(result);
            //result.eto_sector_sku_list = JSON.parse(result.eto_sector_sku_list);

            if (_.get(result, 'eto_sector_sku_list', null) !== null &&
              _.size(_.get(result, 'eto_sector_sku_list', new Array())) > 0) {
              result.eto_sector_sku_list = JSON.parse(result.eto_sector_sku_list);
            }


            //self.basicInfo = result.basic_info;
            self.etoSectorSkus = result.eto_sector_sku_list

          })
          .finally(() => {
            //console.log("COMPLETE /ftie/get-eto-sector-sku-info/");
            eventHub.$emit('loading', false);
          });
      },
      getSfProductline(tab = false) {
        let self = this;
        if (tab) {
          self.skuPnDisplayed = false;
        }
        let requestData = {
          create_by: self.ftie_page_obj.gtc_owner,
          username: self.login_user_name,
          ftie_id: self.ftie_page_obj.ftie_id,
          detail_id: self.ftie_page_obj.request_detail_id
        };
        self.searching = true;
        if (!self.sfdc_prd_line_loading) {
          eventHub.$emit('loading', true);
        }
        self.sfdc_prd_line_loading = true;
        this.$axios
          .post(self.$root.baseUrl + '/nre/customization-nre-pn/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'basic_info', null) !== null &&
              _.size(_.get(result, 'basic_info', new Array())) > 0) {
              result.basic_info = JSON.parse(result.basic_info);
            }
            // result.basic_info = JSON.parse(result.basic_info);

            if (_.get(result, 'sku_pn_info_list_for_nre', null) !== null &&
              _.size(_.get(result, 'sku_pn_info_list_for_nre', new Array())) > 0) {
              result.sku_pn_info_list_for_nre = JSON.parse(result.sku_pn_info_list_for_nre);
            }

            if (_.get(result, 'ref_sku_info_list', null) !== null &&
              _.size(_.get(result, 'ref_sku_info_list', new Array())) > 0) {
              result.ref_sku_info_list = JSON.parse(result.ref_sku_info_list);
            }

            if (_.get(result, 'sfdc_line_info_list', null) !== null &&
              _.size(_.get(result, 'sfdc_line_info_list', new Array())) > 0) {
              result.sfdc_line_info_list = JSON.parse(result.sfdc_line_info_list);
            }
            /*
            console.log("result.sku_pn_info_list_for_nre::");
            console.log(result.sku_pn_info_list_for_nre);
            console.log("result.ref_sku_info_list::");
            console.log(result.ref_sku_info_list);
            console.log("result.basic_info::");
            console.log(result.basic_info);
            console.log("result.sfdc_line_info_list::");
            console.log(result.sfdc_line_info_list);
            */

            self.basicInfo = result.basic_info;
            self.sfdcProducts = result.sfdc_line_info_list
            let cust_pn_without_unique_pn_products = _.filter(self.sfdcProducts, p => _.isArray(p.customization_pn_set) && !_.isEmpty(p.customization_pn_set))
            const map_result = Array.from(
              cust_pn_without_unique_pn_products.reduce((map, item) => {
                const key = `${_.get(item.customization_pn_set[0], 'ship_pn', '')}_${_.get(item.customization_pn_set[0], 'mps_pn', '')}`;
                const value = item.unique_pn.length;

                if (!map.has(key)) {
                  map.set(key, value);
                } else {
                  map.set(key, Math.max(map.get(key), value));
                }

                return map;
              }, new Map())
            ).map(([key, value]) => ({ key, value }))
            console.log("unique_pn map_result");
            console.log(map_result);
            console.log(map_result.some(x => x.value === 0));
            self.without_unique_pn = map_result.some(x => x.value === 0);
          })
          .finally(() => {
            console.log("COMPLETE /nre/customization-nre-pn/");
            //if (realSkuForNreRefresh !== null && realSkuForNreRefresh !== '') {
            //  self.refreshNreQuotes(realSkuForNreRefresh);
            //}
            //self.searching = false;
            //self.resetAddOrCloneNreModalData(true);
            //self.actionEnable = self.checkActionEnable();
            eventHub.$emit('loading', false);
            self.sfdc_prd_line_loading = false;
          });

      },
      getEsInfo() {
        let self = this;

        let requestData = {
          es_id: self.ftie_page_obj.salesforce_es_id,
          request_from: self.ftie_page_obj.request_from
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-es-info/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'es_main_es_info', null) !== null) {
              self.es_main_es_info = JSON.parse(result.es_main_es_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            console.log("Befreo prop self.es_main_es_info:");
            //console.log(self.es_main_es_info);
          });

      },
      getSfEsOptyInfo() {
        let self = this;

        let requestData = {
          es_id: self.ftie_page_obj.salesforce_es_id,
          opty_id: self.ftie_page_obj.salesforce_opty_id,
          request_from: self.ftie_page_obj.request_from
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-sf-info/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'es_main_es_info', null) !== null) {
              self.es_main_es_info = JSON.parse(result.es_main_es_info);
            }

            if (_.get(result, 'sf_es_info', null) !== null) {
              self.sf_es_info = JSON.parse(result.sf_es_info);
            }

            if (_.get(result, 'sf_opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.sf_opty_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            console.log("Befreo prop self.es_main_es_info:");
            //console.log(self.es_main_es_info);
          });

      },
      getUnreadSubject() {
        let self = this;
        self.ftie_page_obj.subjects.map((subject) => {
          if (self.login_user_name == self.ftie_page_obj.gtc_owner || self.login_user_name == self.ftie_page_obj.gro_owner) {
            let not_read_comments = _.filter(subject.comments, item => {
              return item.createby !== self.login_user_name &&
                (item.unread_gro_member === self.login_user_name || item.unread_gtc_member === self.login_user_name)
            })
            if ((subject.comments.length > 0 && not_read_comments.length > 0) || (subject.createby !== self.login_user_name &&
              (subject.unread_gro_member === self.login_user_name || subject.unread_gtc_member === self.login_user_name))) {
              self.$set(subject, "read", false);
            } else {
              self.$set(subject, "read", true);
            }
          } else {
            self.$set(subject, "read", true);
          }

        });
        self.ftie_page_obj.subjects = _.orderBy(self.ftie_page_obj.subjects, ['read', 'update_date'], ['asc', 'desc']);
        self.$forceUpdate();
      },
      getFtieKickoffFiles() {
        let self = this;
        let url = self.$root.baseUrl + '/stage-management/get_kickoff_files';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          ftie_id: self.ftie_page_obj.ftie_id,
        };
        eventHub.$emit('loading', true);
        self.kickoff_files = null;
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let kickoff_files = JSON.parse(res['kickoff_files']);
              self.kickoff_files = kickoff_files;
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      getAutoPnRequests() {
        let self = this;
        let url = self.$root.baseUrl + '/auto-pn/list/';
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              self.autopn_items = res['request_list'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              self.autopn_items = []
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })

      },
      selectCertainSubject(subject_id) {
        let self = this;
        let rowIndex = _.findIndex(self.ftie_page_obj.subjects, { 'subject_id': subject_id.toString() });
        let row = _.find(self.ftie_page_obj.subjects, { 'subject_id': subject_id.toString() });
        if (rowIndex) {
          let subjectRef = `subject_${subject_id}`;
          let a = self.$refs[subjectRef];
          self.$refs[subjectRef].scrollIntoView({ behavior: "smooth" });
          //self.$refs.selectableTable.selectRow(rowIndex);
          self.handleRowClicked(row, rowIndex);
        }
        self.$refs['display-related-attachments-modal'].hide();
      },
      onShown() {
        this.isCollapsed = false;
      },
      onHidden() {
        this.isCollapsed = true;
      },
      onTabChange(newIndex) {
        let self = this;
        if (newIndex !== 3) {
          // not SKU PN tab should be displayed
          self.skuPnDisplayed = true;
        }
      },
      getTrackingData() {
        this.$refs.custTracking.getLog();
      },
      getLatestTracking() {
        let self = this;
        let requestData = {
          ftie_id: self.ftie_page_obj.ftie_id,
        };
        self.tracking_data_loading = true;
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-latest-tracking-log/', requestData)
          .then(res => {
            let result = res.data;
            self.ftie_page_obj.tracking_stage = _.get(result, 'tracking_stage', null);
            self.ftie_page_obj.tracking_status = _.get(result, 'tracking_status', null);
            self.ftie_page_obj.tracking_owner = _.get(result, 'tracking_owner', null);

          })
          .finally(() => {
            self.tracking_data_loading = false;
          });

      },
      reopenSubTicket() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/reopen-sub-ticket/';

        // let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === self.login_user_name; })
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.getFtiePage(self.ftie_page_obj.ftie_id);
          })
      },
      updatePnNeedFlag() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/update-pn-need/';

        // let members = _.filter(self.ftie_page_obj.mail_loop, item => { return item.member_gulid === self.login_user_name; })
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          need_flag: self.ftie_page_obj.need_unique_pn_flag
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            //self.getFtiePage(self.ftie_page_obj.ftie_id);
          })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcFtiePage.vue